var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "other" },
    [
      _c(
        "div",
        { staticClass: "citySelect" },
        [
          _c(
            "el-dropdown",
            { on: { command: _vm.handleCommand } },
            [
              _c("span", { staticClass: "el-dropdown-link font17" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$store.state.Counter.city) +
                    "\n        "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      staticStyle: { "font-size": "17px" },
                      attrs: { command: "杭州" }
                    },
                    [_vm._v("杭州")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      staticStyle: { "font-size": "17px" },
                      attrs: { command: "上海" }
                    },
                    [_vm._v("上海")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.mainGroup === "创新"
        ? _c(
            "div",
            { staticClass: "normal" },
            _vm._l(_vm.operations, function(item, index) {
              return _c(
                "el-radio",
                {
                  key: index,
                  attrs: { label: item.en },
                  on: { change: _vm.changeCurrent },
                  model: {
                    value: _vm.operation,
                    callback: function($$v) {
                      _vm.operation = $$v
                    },
                    expression: "operation"
                  }
                },
                [_vm._v(_vm._s(item.ch))]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.subgroup == "租房"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toZuwoCenter()
                    }
                  }
                },
                [_vm._v("小鸡租窝")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { margin: "40px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.toIndexPage()
                }
              }
            },
            [_vm._v("数据列表")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              class: { "item-box": _vm.redDot },
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.onPageClick("需求中心")
                }
              }
            },
            [_vm._v("需求中心")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "operate",
              expression: "current === 'operate'"
            }
          ],
          staticClass: "newOperate"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("新运营小队")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _vm.seeNewoperate
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/newOperateTeam/summaryTable"
                        })
                      }
                    }
                  },
                  [_vm._v("\n        顾问端\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.seeNewoperate
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/newOperateTeam/customerSumTable"
                        })
                      }
                    }
                  },
                  [_vm._v("\n        客户端\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.seeSecoperate
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/newOperateTeam/brokerIndex"
                        })
                      }
                    }
                  },
                  [_vm._v("\n        经纪人端\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/shanghai/articleManage" })
                  }
                }
              },
              [_vm._v("\n        文章管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/reportCenter" })
                  }
                }
              },
              [_vm._v("\n        报告中心\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/opsIdentityToggle" })
                  }
                }
              },
              [_vm._v("\n        运营身份切换\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/FunctionViewStats" })
                  }
                }
              },
              [_vm._v("\n        功能浏览量统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/consultButtonClickData" })
                  }
                }
              },
              [_vm._v("\n        咨询按钮点击数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({
                      path: "/autumnBusinessActivity",
                      query: { type: "yunying" }
                    })
                  }
                }
              },
              [_vm._v("\n        金秋商务活动\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({
                      path: "/double12BusinessActivity"
                    })
                  }
                }
              },
              [_vm._v("\n          十二月商务活动\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/homePageClickData" })
                  }
                }
              },
              [_vm._v("\n        首页功能点击数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/addAgentStore" })
                  }
                }
              },
              [_vm._v("\n        增加门店\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/dataMonitoring" })
                  }
                }
              },
              [_vm._v("\n        数据监控\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/surveyQuestionnaire" })
                  }
                }
              },
              [_vm._v("\n        用户调研\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("公众号管理")
                  }
                }
              },
              [_vm._v("\n        公众号管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/diversionAppData" })
                  }
                }
              },
              [_vm._v("\n        导流小程序数据统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/couponManage")
                  }
                }
              },
              [_vm._v("\n        特惠项目管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("看房笔记数据看板")
                  }
                }
              },
              [_vm._v("\n        看房笔记数据看板\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("补贴楼盘数据看板")
                  }
                }
              },
              [_vm._v("\n        补贴楼盘数据看板\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/houseGuestDirectData")
                  }
                }
              },
              [_vm._v("\n        房客直聊数据统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/houseGuestDirectChatDetail")
                  }
                }
              },
              [_vm._v("\n        房客直聊聊天明细\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/houseGuestDirectOwnerDetail")
                  }
                }
              },
              [_vm._v("\n        房东详情看板\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toFangdongHouseModify()
                  }
                }
              },
              [_vm._v("\n        房东上传房源详情审核\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/bannerControl" })
                  }
                }
              },
              [_vm._v("\n        轮播banner管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toGuwenHoutai()
                  }
                }
              },
              [_vm._v("\n        顾问成交服务后台看板\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/CustomerServicedata" })
                  }
                }
              },
              [_vm._v("\n        客服数据查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("导入小程序数据")
                  }
                }
              },
              [_vm._v("\n        导入小程序数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({
                      path: "/evaluationPageClickData"
                    })
                  }
                }
              },
              [_vm._v("\n        评测功能点击数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/returnReward" })
                  }
                }
              },
              [_vm._v("\n        B端回归奖励\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getZhList()
                  }
                }
              },
              [_vm._v("\n        新房专业完整度\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/bigScreenMapDisplay" })
                  }
                }
              },
              [_vm._v("\n        大屏幕地图展示\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/AgentStoreAudit" })
                  }
                }
              },
              [_vm._v("\n        经纪人门店审核\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/houseSelectService" })
                  }
                }
              },
              [_vm._v("\n        选房服务后台\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/estateTagManage" })
                  }
                }
              },
              [_vm._v("\n        楼盘标签\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/featuredListings" })
                  }
                }
              },
              [_vm._v("\n        精选房源\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticClass: "operate"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("运营小队")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "alltitle" }, [_vm._v("新房")]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "cititle" }, [_vm._v("楼盘类功能")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("资料审核")
                      }
                    }
                  },
                  [_vm._v("\n            预计开盘审核\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("新房图片审核")
                          }
                        }
                      },
                      [_vm._v("\n            新房图片审核\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("追踪预计开盘")
                          }
                        }
                      },
                      [_vm._v("\n            追踪预计开盘\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("楼盘评论数")
                          }
                        }
                      },
                      [_vm._v("\n            楼盘评论数\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.checkDate1,
                        callback: function($$v) {
                          _vm.checkDate1 = $$v
                        },
                        expression: "checkDate1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("新盘点击量排名")
                      }
                    }
                  },
                  [_vm._v("\n            新盘点击量排名\n          ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "cibuttonwarp" }, [
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("给顾问加分")
                        }
                      }
                    },
                    [_vm._v("\n              给顾问加分\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.$store.state.Counter.city === "杭州"
                    ? _c(
                        "button",
                        {
                          staticClass: "normal cibutton",
                          on: {
                            click: function($event) {
                              return _vm.onPageClick("顾问回答审核加分")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              顾问回答审核加分\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.Counter.city === "杭州"
                    ? _c(
                        "button",
                        {
                          staticClass: "normal cibutton",
                          on: {
                            click: function($event) {
                              return _vm.onPageClick("微控平台登录通道1")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              微控平台登录通道1\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.Counter.city === "杭州"
                    ? _c(
                        "button",
                        {
                          staticClass: "normal cibutton",
                          on: {
                            click: function($event) {
                              return _vm.onPageClick("微控平台登录通道2")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              微控平台登录通道2\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("置业顾问分享话题的人数和排名")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              置业顾问分享话题的人数和排名\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: { click: _vm.getConsultantShareList }
                    },
                    [_vm._v("\n              顾问分享名单\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.$store.state.Counter.city === "杭州"
                    ? _c(
                        "button",
                        {
                          staticClass: "normal cibutton",
                          on: {
                            click: function($event) {
                              return _vm.onPageClick("朋友圈加分失败")
                            }
                          }
                        },
                        [_vm._v("\n              朋友圈加分失败\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.Counter.city === "杭州"
                    ? _c(
                        "button",
                        {
                          staticClass: "normal cibutton",
                          on: {
                            click: function($event) {
                              return _vm.onPageClick("朋友圈加分")
                            }
                          }
                        },
                        [_vm._v("\n              朋友圈加分\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("搜索某人朋友圈")
                        }
                      }
                    },
                    [_vm._v("\n              搜索某人朋友圈\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("朋友圈统计")
                        }
                      }
                    },
                    [_vm._v("\n              朋友圈统计\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("发布朋友圈")
                        }
                      }
                    },
                    [_vm._v("\n              发布朋友圈\n            ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("入驻审核")
                      }
                    }
                  },
                  [_vm._v("\n            入驻审核\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("头像审核")
                      }
                    }
                  },
                  [_vm._v("\n            头像审核\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("群聊申诉", "顾问")
                          }
                        }
                      },
                      [_vm._v("\n            顾问群聊申诉\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("销售大群审核")
                          }
                        }
                      },
                      [_vm._v("\n            销售大群审核\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("举报审核")
                          }
                        }
                      },
                      [_vm._v("\n            举报审核\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toSalesDynamic()
                      }
                    }
                  },
                  [_vm._v("\n            置业顾问动态审核\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton cibutton",
                    on: { click: _vm.toTaskAudit }
                  },
                  [_vm._v("\n            限时任务审核\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/transactionContract")
                      }
                    }
                  },
                  [_vm._v("\n            成交审核\n          ")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("最近留言")
                      }
                    }
                  },
                  [_vm._v("\n            最近留言\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("客服评价")
                          }
                        }
                      },
                      [_vm._v("\n            客服评价\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("搜索解禁")
                      }
                    }
                  },
                  [_vm._v("\n            搜索解禁\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("话题文章置顶")
                          }
                        }
                      },
                      [_vm._v("\n            话题文章置顶\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("回复楼盘提问")
                          }
                        }
                      },
                      [_vm._v("\n            回复楼盘提问\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("群聊灌水")
                      }
                    }
                  },
                  [_vm._v("\n            群聊灌水\n          ")]
                )
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("楼市提问")
                          }
                        }
                      },
                      [_vm._v("\n            客户提问审核\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("建议反馈")
                          }
                        }
                      },
                      [_vm._v("\n            建议反馈\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("评价审核")
                      }
                    }
                  },
                  [_vm._v("\n            评价审核\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getjudegcomment()
                      }
                    }
                  },
                  [_vm._v("\n            话题审核\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toLive()
                      }
                    }
                  },
                  [_vm._v("直播审核")]
                )
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("群聊申诉", "用户")
                          }
                        }
                      },
                      [_vm._v("\n            用户群聊申诉\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("业主群审核")
                          }
                        }
                      },
                      [_vm._v("\n            业主群审核\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showQun("假用户消息")
                      }
                    }
                  },
                  [_vm._v("\n            假用户消息\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.showQun("消息通知")
                          }
                        }
                      },
                      [_vm._v("\n            消息通知\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("聊天举报")
                          }
                        }
                      },
                      [_vm._v("\n            聊天举报\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.getQlwgRecord()
                          }
                        }
                      },
                      [_vm._v("\n            群聊违规\n          ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toessay()
                      }
                    }
                  },
                  [_vm._v("\n            合作公众号\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/uploadAd")
                      }
                    }
                  },
                  [_vm._v("\n            广告位上传\n          ")]
                )
              ]),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showPageHits("首页")
                      }
                    }
                  },
                  [_vm._v("\n            首页点击数\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "苏州"
                  ? _c(
                      "div",
                      { staticClass: "add-margin" },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: _vm.posterType,
                              callback: function($$v) {
                                _vm.posterType = $$v
                              },
                              expression: "posterType"
                            }
                          },
                          _vm._l(_vm.szPosterTypeList, function(item) {
                            return _c(
                              "el-option",
                              { key: item, attrs: { value: item } },
                              [_vm._v(_vm._s(item))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "苏州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: { click: _vm.drawPoster }
                      },
                      [_vm._v("\n            绘制海报\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "div",
                      {
                        staticClass: "cibuttonwarp",
                        staticStyle: { margin: "0" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "add-margin" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.posterType,
                                  callback: function($$v) {
                                    _vm.posterType = $$v
                                  },
                                  expression: "posterType"
                                }
                              },
                              _vm._l(_vm.hzPosterTypeList, function(item) {
                                return _c(
                                  "el-option",
                                  { key: item, attrs: { value: item } },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.posterType === "每日楼市" || !_vm.posterType
                          ? _c(
                              "button",
                              {
                                staticClass: "normal cibutton",
                                on: { click: _vm.drawPoster }
                              },
                              [_vm._v("\n              绘制海报\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.posterType === "比价表"
                          ? _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: { placeholder: "输入楼盘名称" },
                              model: {
                                value: _vm.building_name,
                                callback: function($$v) {
                                  _vm.building_name = $$v
                                },
                                expression: "building_name"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.posterType !== "每日楼市" && _vm.posterType
                          ? _c(
                              "button",
                              {
                                staticClass: "normal cibutton",
                                staticStyle: {
                                  overflow: "hidden",
                                  position: "relative"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              请选择截图\n              "
                                ),
                                _c("input", {
                                  attrs: {
                                    type: "file",
                                    multiple: "",
                                    id: "input_image"
                                  },
                                  on: { change: _vm.voteRoomPoster }
                                })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getYunYinCountSysterm()
                      }
                    }
                  },
                  [_vm._v("\n            数据系统\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getchuangxin()
                      }
                    }
                  },
                  [_vm._v("\n            产品数据系统\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/newHouseExtent")
                      }
                    }
                  },
                  [_vm._v("\n            新房专业完整度\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/twoHouseExtent")
                      }
                    }
                  },
                  [_vm._v("\n            二手房专业完整度\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getAreaList()
                      }
                    }
                  },
                  [_vm._v("\n            常规完整度\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.checkEstateImageNum }
                  },
                  [_vm._v("\n            楼盘图片视频数量\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getSalePut()
                      }
                    }
                  },
                  [_vm._v("\n            销售上传\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getQlList()
                      }
                    }
                  },
                  [_vm._v("\n            群聊条数查询\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/topicRecord" })
                      }
                    }
                  },
                  [_vm._v("\n            智能话题识别\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/bankDiet" })
                      }
                    }
                  },
                  [_vm._v("\n            贷款看板\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toEmotionRecord }
                  },
                  [_vm._v("\n            智能情绪识别\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toHaterIdentify }
                  },
                  [_vm._v("\n            小黑子识别\n          ")]
                )
              ]),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.showSalerStatus }
                  },
                  [_vm._v("\n            销售活跃情况\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.getStatisticsData }
                  },
                  [_vm._v("\n            销售动态统计\n          ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: { click: _vm.getShareWeekTop }
                      },
                      [_vm._v("\n            销售上周积分排名\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.checkDate1,
                        callback: function($$v) {
                          _vm.checkDate1 = $$v
                        },
                        expression: "checkDate1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getShareTop("销售", _vm.areaValue)
                      }
                    }
                  },
                  [_vm._v("\n            销售分享排名\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showMsgNum("置业顾问")
                      }
                    }
                  },
                  [_vm._v("\n            置业顾问咨询量排名\n          ")]
                )
              ]),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _vm.$store.state.Counter.city === "苏州"
                  ? _c(
                      "div",
                      { staticClass: "add-margin" },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            size: "small",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "选择日期"
                          },
                          model: {
                            value: _vm.checkDate1,
                            callback: function($$v) {
                              _vm.checkDate1 = $$v
                            },
                            expression: "checkDate1"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "苏州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.getSzInvite()
                          }
                        }
                      },
                      [_vm._v("\n            苏州运营分享\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.getInvite()
                          }
                        }
                      },
                      [_vm._v("\n            运营分享\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.findFried()
                          }
                        }
                      },
                      [_vm._v("\n            炒群记录\n          ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("积分商城")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toPointsMall }
                  },
                  [_vm._v("\n            积分商城\n          ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("商务跟踪")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.GoToRoutineTrail()
                      }
                    }
                  },
                  [_vm._v("\n            常规跟踪表\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.GoToBusinessPlanTrail()
                      }
                    }
                  },
                  [_vm._v("\n            商务计划跟踪表\n          ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("亚运活动")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/asiaGamesMedal")
                      }
                    }
                  },
                  [_vm._v("\n            亚运奖牌榜\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/asiaGamesQuestion")
                      }
                    }
                  },
                  [_vm._v("\n            每日竞猜题目\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/asiaGamesComment")
                      }
                    }
                  },
                  [_vm._v("\n            互动评论管理\n          ")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("二手房")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _vm.$store.state.Counter.city === "杭州"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("中介审核")
                      }
                    }
                  },
                  [_vm._v("\n        中介审核\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.Counter.city === "杭州"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toCheckImage("楼盘")
                      }
                    }
                  },
                  [_vm._v("\n        二手楼盘图片审核\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.Counter.city === "杭州"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toCheckImage("房源")
                      }
                    }
                  },
                  [_vm._v("\n        二手房源图片审核\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.Counter.city === "杭州"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("房源审核")
                      }
                    }
                  },
                  [_vm._v("\n        房源审核\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.Counter.city === "杭州"
              ? _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.checkDate1,
                        callback: function($$v) {
                          _vm.checkDate1 = $$v
                        },
                        expression: "checkDate1"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.Counter.city === "杭州"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showEstateHits("二手房")
                      }
                    }
                  },
                  [_vm._v("\n        二手盘点击量排名\n      ")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("猩号")]),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "杭州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP进群审核")
                      }
                    }
                  },
                  [_vm._v("\n        APP进群审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP建群审核")
                      }
                    }
                  },
                  [_vm._v("\n        APP建群审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP举报审核")
                      }
                    }
                  },
                  [_vm._v("\n        APP举报审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP申诉")
                      }
                    }
                  },
                  [_vm._v("\n        APP申诉\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP反馈")
                      }
                    }
                  },
                  [_vm._v("\n        APP反馈\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("干货地图")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("新房", "全城左")
                  }
                }
              },
              [_vm._v("\n        新房左\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("新房", "全城右")
                  }
                }
              },
              [_vm._v("\n        新房右\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("新房", "全城")
                  }
                }
              },
              [_vm._v("\n        新房整\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("待首开", "全城左")
                  }
                }
              },
              [_vm._v("\n        待首开和土拍左\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("待首开", "全城右")
                  }
                }
              },
              [_vm._v("\n        待首开和土拍右\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("待首开", "全城")
                  }
                }
              },
              [_vm._v("\n        待首开和土拍整\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("土拍", "全城左")
                  }
                }
              },
              [_vm._v("\n        土拍左\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("土拍", "全城右")
                  }
                }
              },
              [_vm._v("\n        土拍右\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("土拍", "全城")
                  }
                }
              },
              [_vm._v("\n        土拍整\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("土拍圆点", "全城左")
                  }
                }
              },
              [_vm._v("\n        土拍圆点左\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("土拍圆点", "全城右")
                  }
                }
              },
              [_vm._v("\n        土拍圆点右\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("土拍圆点", "全城")
                  }
                }
              },
              [_vm._v("\n        土拍圆点整\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("公示登记", "全城左")
                  }
                }
              },
              [_vm._v("\n        公示登记左\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("公示登记", "全城右")
                  }
                }
              },
              [_vm._v("\n        公示登记右\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("公示登记", "全城")
                  }
                }
              },
              [_vm._v("\n        公示登记整\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("中签率")
                  }
                }
              },
              [_vm._v("\n        中签率\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("热度")
                  }
                }
              },
              [_vm._v("热度")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("板块")
                  }
                }
              },
              [_vm._v("\n        板块图\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("板块地图土拍")
                  }
                }
              },
              [_vm._v("\n        板块地图土拍\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("getBounds")
                  }
                }
              },
              [_vm._v("\n        城市地图\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("其他")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "div",
              { staticClass: "add-margin" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.codeType,
                      callback: function($$v) {
                        _vm.codeType = $$v
                      },
                      expression: "codeType"
                    }
                  },
                  _vm._l(_vm.codeTypeList, function(item) {
                    return _c(
                      "el-option",
                      { key: item, attrs: { value: item } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "normal cibutton", on: { click: _vm.getMpCode } },
              [_vm._v("小程序码")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("评价审核")
                  }
                }
              },
              [_vm._v("\n        评价审核\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEssayData()
                  }
                }
              },
              [_vm._v("\n        合作公众号分享数据\n      ")]
            )
          ]),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "杭州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.checkDate1,
                        callback: function($$v) {
                          _vm.checkDate1 = $$v
                        },
                        expression: "checkDate1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showEstateHits("二手房")
                      }
                    }
                  },
                  [_vm._v("\n        二手盘点击量排名\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showMsgNum("经纪人")
                      }
                    }
                  },
                  [_vm._v("\n        经纪人咨询量排名\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getShareTop("经纪人")
                      }
                    }
                  },
                  [_vm._v("\n        经纪人分享排名\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "杭州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getEstateGS("正在公示")
                      }
                    }
                  },
                  [_vm._v("\n        正在公示\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getEstateGS("正在登记")
                      }
                    }
                  },
                  [_vm._v("\n        正在登记\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("专家入驻")
                      }
                    }
                  },
                  [_vm._v("\n        专家入驻\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.getSaleJoinData }
                  },
                  [_vm._v("\n        近期入驻人数\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.getSalesMsgNum }
                  },
                  [_vm._v("\n        顾问群聊消息数排名\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.setChatSales }
                  },
                  [_vm._v("\n        拉顾问进群\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("留言举报")
                      }
                    }
                  },
                  [_vm._v("\n        留言举报审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.searchGsReal()
                      }
                    }
                  },
                  [_vm._v("\n        追踪公示楼盘数据\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getYuyueInfo()
                      }
                    }
                  },
                  [_vm._v("\n        楼盘预约\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.noNewsOrImages("1")
                      }
                    }
                  },
                  [_vm._v("\n        小区内配套\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.addNews()
                      }
                    }
                  },
                  [_vm._v("\n        新增动态/配套\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getAdvanceList()
                      }
                    }
                  },
                  [_vm._v("\n        预售证信息\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getAreaShare()
                      }
                    }
                  },
                  [_vm._v("\n        区域销售分享\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getWkMessage()
                      }
                    }
                  },
                  [_vm._v("\n        微信群聊统计\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.showQun("创建小群")
                      }
                    }
                  },
                  [_vm._v("\n        创建小群\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("自动问答")
                      }
                    }
                  },
                  [_vm._v("\n        自动问答管理\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toGetOneDayTalk("运营")
                      }
                    }
                  },
                  [_vm._v("\n        群聊记录\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.changeTopicLabel()
                      }
                    }
                  },
                  [_vm._v("\n        话题类目\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toCheckTalk }
                  },
                  [_vm._v("\n        群聊地毯式检查\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toCheckWeiguiTalk }
                  },
                  [_vm._v("\n        聊天图片违规\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "苏州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.checkDate1,
                        callback: function($$v) {
                          _vm.checkDate1 = $$v
                        },
                        expression: "checkDate1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getShareNum("楼市小V")
                      }
                    }
                  },
                  [_vm._v("\n        合作中介分享\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getShareNum("置业顾问")
                      }
                    }
                  },
                  [_vm._v("\n        置业顾问分享\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.setSubstitute("")
                      }
                    }
                  },
                  [_vm._v("\n        变回自己\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "苏州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.szYuShouList()
                      }
                    }
                  },
                  [_vm._v("\n        预售证楼盘\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("拿证审核")
                      }
                    }
                  },
                  [_vm._v("\n        拿证审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("分配客户")
                      }
                    }
                  },
                  [_vm._v("\n        手动分配客户\n      ")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.current === "business",
                expression: "current === 'business'"
              }
            ],
            staticClass: "business"
          },
          [
            _c("h3", [_vm._v("新商务小队")]),
            _vm._v(" "),
            _c("div", { staticClass: "cititle" }, [_vm._v("全部功能")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cibuttonwarp" },
              [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/newBusinessTeam/businessCustomerSum"
                        })
                      }
                    }
                  },
                  [_vm._v("\n          商务数据看板\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/newBusinessTeam/businessAdvertisement"
                        })
                      }
                    }
                  },
                  [_vm._v("\n          商务广告数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/infoOfflineManage" })
                      }
                    }
                  },
                  [_vm._v("\n          信息下架管理\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/newBuildBoard" })
                      }
                    }
                  },
                  [_vm._v("\n          新房楼盘数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/guwenImpactBoard" })
                      }
                    }
                  },
                  [_vm._v("\n          置业顾问效果数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/acCustomerList" })
                      }
                    }
                  },
                  [_vm._v("\n          活动客户列表\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "red-point-item",
                    attrs: { "is-dot": _vm.pointData.hasAllAccountDetail }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "cibutton",
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              path: "/allAccountDetail"
                            })
                          }
                        }
                      },
                      [_vm._v("\n            全号明细\n          ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({
                          path: "/autumnBusinessActivity"
                        })
                      }
                    }
                  },
                  [_vm._v("\n          金秋商务活动\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/competitorsAddata" })
                      }
                    }
                  },
                  [_vm._v("\n          竞品广告数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/transactionEntry" })
                      }
                    }
                  },
                  [_vm._v("\n          成交录入\n        ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", [_vm._v("商务小队")]),
            _vm._v(" "),
            _c("div", { staticClass: "cititle" }, [_vm._v("红包相关")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cibuttonwarp" },
              [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.GoToRedPacket()
                      }
                    }
                  },
                  [_vm._v("\n          红包活动\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "red-point-item",
                    attrs: { "is-dot": _vm.pointData.hasRedpacketAudit }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "cibutton",
                        on: {
                          click: function($event) {
                            return _vm.GoToRedPacketAudit()
                          }
                        }
                      },
                      [_vm._v("\n            红包活动审核\n          ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.GoToRedPacketStatistics()
                      }
                    }
                  },
                  [_vm._v("\n          红包数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.GoToErrRedPacket()
                      }
                    }
                  },
                  [_vm._v("\n          失败红包处理\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/asiaGamesPreheat")
                      }
                    }
                  },
                  [_vm._v("\n          活动红包数据\n        ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cititle" }, [_vm._v("优惠券相关")]),
            _vm._v(" "),
            _c("div", { staticClass: "cibuttonwarp" }, [
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/couponManage")
                    }
                  }
                },
                [_vm._v("\n          特惠项目管理\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/activityCustomerList")
                    }
                  }
                },
                [_vm._v("\n          活动客户列表\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/dealSubsidy")
                    }
                  }
                },
                [_vm._v("\n          百万补贴项目管理\n        ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cititle" }, [_vm._v("广告相关")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cibuttonwarp" },
              [
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("楼盘集合")
                          }
                        }
                      },
                      [_vm._v("\n          策划广告数据统计\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.getAdTotal }
                  },
                  [_vm._v("\n          广告位统计\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.getAdTotal1 }
                  },
                  [_vm._v("\n          广告曝光量统计\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/uploadAd")
                      }
                    }
                  },
                  [_vm._v("\n          广告位上传\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "red-point-item",
                    attrs: { "is-dot": _vm.pointData.hasAdAudit }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "cibutton",
                        on: {
                          click: function($event) {
                            return _vm.routerPushTo("/checkAd")
                          }
                        }
                      },
                      [_vm._v("\n            广告位审核\n          ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/adPublication")
                      }
                    }
                  },
                  [_vm._v("\n          广告上刊记录查询\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/adScreen")
                      }
                    }
                  },
                  [_vm._v("\n          广告截图\n        ")]
                ),
                _vm._v(" "),
                _vm.erp_id == "2hwvqwwo1ow"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.routerPushTo("/cooperationList")
                          }
                        }
                      },
                      [_vm._v("\n          联系方式合作\n        ")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cititle" }, [_vm._v("分配客户相关")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cibuttonwarp" },
              [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/CustomerDistribution")
                      }
                    }
                  },
                  [_vm._v("\n          手动分配客户\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-badge",
                  {
                    staticClass: "red-point-item",
                    attrs: { "is-dot": _vm.pointData.hasCouponAudit }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "cibutton",
                        on: {
                          click: function($event) {
                            return _vm.routerPushTo("/assignCustomerReviews")
                          }
                        }
                      },
                      [_vm._v("\n            手动分配客户审核\n          ")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/assignCustomerRecords")
                      }
                    }
                  },
                  [_vm._v("\n          查询分配记录\n        ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            _vm.listName = "assignCustomer"
                          }
                        }
                      },
                      [_vm._v("\n          分配客户情况\n        ")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cititle" }, [_vm._v("其他")]),
            _vm._v(" "),
            _c("div", { staticClass: "cibuttonwarp" }, [
              _c(
                "div",
                { staticClass: "add-margin" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      size: "small",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    model: {
                      value: _vm.checkDate1,
                      callback: function($$v) {
                        _vm.checkDate1 = $$v
                      },
                      expression: "checkDate1"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.showMsgNum("置业顾问")
                    }
                  }
                },
                [_vm._v("\n          置业顾问咨询量排名\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      _vm.listName = "guwenFuwu"
                    }
                  }
                },
                [_vm._v("\n          顾问情况\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "normal" },
                [
                  _c(
                    "button",
                    {
                      style: { backgroundColor: _vm.oldFirst ? "red" : "" },
                      on: {
                        click: function($event) {
                          _vm.oldFirst = !_vm.oldFirst
                        }
                      }
                    },
                    [_vm._v("\n            旧访问优先\n          ")]
                  ),
                  _vm._v("\n          客户比对\n          "),
                  _c(
                    "el-select",
                    {
                      ref: "agent1Select",
                      attrs: {
                        filterable: "",
                        placeholder: "选择楼盘",
                        "default-first-option": "",
                        "remote-method": _vm.searchEstate,
                        remote: ""
                      },
                      model: {
                        value: _vm.real_estate_id,
                        callback: function($$v) {
                          _vm.real_estate_id = $$v
                        },
                        expression: "real_estate_id"
                      }
                    },
                    _vm._l(_vm.matchEstates, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.real_estate_name, value: item.id }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "file" },
                    on: { change: _vm.comparingCustomers }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.GoToRoutineTrail()
                    }
                  }
                },
                [_vm._v("\n          常规跟踪表\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.GoToBusinessPlanTrail()
                    }
                  }
                },
                [_vm._v("\n          商务计划跟踪表\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/dealCount")
                    }
                  }
                },
                [_vm._v("\n          成交数量\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/discountsExamine")
                    }
                  }
                },
                [_vm._v("\n          特惠信息审核\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/discountsExamineNew")
                    }
                  }
                },
                [_vm._v("\n          特惠信息审核·新\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/reservationShowings")
                    }
                  }
                },
                [_vm._v("\n          预约看房活动\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/estateChatSearch")
                    }
                  }
                },
                [_vm._v("\n          查询楼盘私聊信息\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/privateCallback")
                    }
                  }
                },
                [_vm._v("\n          私聊回拨查询\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/fourthBooth")
                    }
                  }
                },
                [_vm._v("\n          第四展位\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/brandStore")
                    }
                  }
                },
                [_vm._v("\n          品牌馆编辑\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      _vm.showZxTable = true
                    }
                  }
                },
                [_vm._v("\n          装修推广数据\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      _vm.showZxConsult = true
                    }
                  }
                },
                [_vm._v("\n          装修电话咨询统计\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/manageProperties")
                    }
                  }
                },
                [_vm._v("\n          小阳春活动\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/ManageAffarisTables")
                    }
                  }
                },
                [_vm._v("\n          管理报表\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/presaleInfo")
                    }
                  }
                },
                [_vm._v("\n          预售证信息\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/CooperationManagement")
                    }
                  }
                },
                [_vm._v("\n          招商合作\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/cooperationList")
                    }
                  }
                },
                [_vm._v("\n          联系方式合作\n        ")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "market",
              expression: "current === 'market'"
            }
          ],
          staticClass: "market"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("销售小队")]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("全部功能")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cibuttonwarp" },
            [
              _c(
                "el-badge",
                {
                  staticClass: "red-point-item",
                  attrs: { "is-dot": _vm.pointData.hasDesignerAudit }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      staticStyle: { margin: "0" },
                      on: {
                        click: function($event) {
                          return _vm.routerPushTo("/auditList")
                        }
                      }
                    },
                    [_vm._v("\n          设计师入驻审核\n        ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-badge",
                {
                  staticClass: "red-point-item",
                  attrs: { "is-dot": _vm.pointData.hasDecorationAudit }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      staticStyle: { margin: "0" },
                      on: {
                        click: function($event) {
                          return _vm.routerPushTo("/decorationPlanAudit")
                        }
                      }
                    },
                    [_vm._v("\n          装修方案审核\n        ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/DecorationPlan")
                    }
                  }
                },
                [_vm._v("\n        装修方案\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/decorationStatisticsTable")
                    }
                  }
                },
                [_vm._v("\n        装修统计\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/decorationCompanyConsult")
                    }
                  }
                },
                [_vm._v("\n        装修公司咨询分配\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/storeMap")
                    }
                  }
                },
                [_vm._v("\n        门店地图\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/opsIdentityToggle" })
                    }
                  }
                },
                [_vm._v("\n        运营身份切换\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-badge",
                {
                  staticClass: "red-point-item",
                  attrs: { "is-dot": _vm.pointData.hasManagerAudit }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "cibutton",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            path: "/storeManageModify"
                          })
                        }
                      }
                    },
                    [_vm._v("\n          店长申请审核\n        ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/jmh2DataStatis" })
                    }
                  }
                },
                [_vm._v("\n        鸡米花套餐购买统计表\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/agentConsumeTable")
                    }
                  }
                },
                [_vm._v("\n        经纪人付费明细\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.routerPushTo("/renewalDashboard")
                    }
                  }
                },
                [_vm._v("\n        续费看板\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/businessReconciliation"
                      })
                    }
                  }
                },
                [_vm._v("\n        二手业务核对\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/agentBenefitsData" })
                    }
                  }
                },
                [_vm._v("\n        经纪人权益情况\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/agentDealChampionPoster"
                      })
                    }
                  }
                },
                [_vm._v("\n        成交达人海报\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/addAgentStore" })
                    }
                  }
                },
                [_vm._v("\n        增加门店\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/agentPosterDealdata" })
                    }
                  }
                },
                [_vm._v("\n        经纪人海报成交数据\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/manualGroupbuying" })
                    }
                  }
                },
                [_vm._v("\n        手动拼团成功\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/sendInviteCard" })
                    }
                  }
                },
                [_vm._v("\n        发放拉新券\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/AgentTopup" })
                    }
                  }
                },
                [_vm._v("\n        经纪人充值\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/AgentStoreAudit" })
                    }
                  }
                },
                [_vm._v("\n        经纪人门店审核\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/agentUploadRecord" })
                    }
                  }
                },
                [_vm._v("\n        经纪人上传成交数据审核\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/bigScreenMapDisplay" })
                    }
                  }
                },
                [_vm._v("\n        大屏幕地图展示\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/houseSelectService" })
                    }
                  }
                },
                [_vm._v("\n        选房服务后台\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/estateTagManage" })
                    }
                  }
                },
                [_vm._v("\n        楼盘标签\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ path: "/featuredListings" })
                    }
                  }
                },
                [_vm._v("\n        精选房源\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "xinghao",
              expression: "current === 'xinghao'"
            }
          ],
          staticClass: "market"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("猩群运营")]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("全部功能")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("发空间说")
                  }
                }
              },
              [_vm._v("\n        发空间说\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("猩号炒群")
                  }
                }
              },
              [_vm._v("\n        猩号炒群\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("猩号炒频道")
                  }
                }
              },
              [_vm._v("\n        猩号炒频道\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("猩号灌水")
                  }
                }
              },
              [_vm._v("\n        猩号空间说灌水\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("造假用户")
                  }
                }
              },
              [_vm._v("\n        选择头像昵称\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.showQun("假用户消息")
                  }
                }
              },
              [_vm._v("\n        炒小鸡选房的群\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("频道管理")
                  }
                }
              },
              [_vm._v("\n        频道管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("运营助手")
                  }
                }
              },
              [_vm._v("\n        运营助手\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getUserNum()
                  }
                }
              },
              [_vm._v("\n        猩群用户数量\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("猩号APP数据")
                  }
                }
              },
              [_vm._v("\n        APP整体数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.showXHTalkTotal }
              },
              [_vm._v("\n        猩群话题发布统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.showxHGSTotal }
              },
              [_vm._v("\n        猩群空间说灌水统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.changeListName("groupWaterTable")
                  }
                }
              },
              [_vm._v("\n        空间群灌水统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.changeListName("channelWaterTable")
                  }
                }
              },
              [_vm._v("\n        频道灌水统计\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.toCountSharevisite }
              },
              [_vm._v("\n        分享链接统计\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("猩号")]),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "杭州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP进群审核")
                      }
                    }
                  },
                  [_vm._v("\n        APP进群审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP建群审核")
                      }
                    }
                  },
                  [_vm._v("\n        APP建群审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP举报审核")
                      }
                    }
                  },
                  [_vm._v("\n        APP举报审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP申诉")
                      }
                    }
                  },
                  [_vm._v("\n        APP申诉\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("APP反馈")
                      }
                    }
                  },
                  [_vm._v("\n        APP反馈\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("旅游")]),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "杭州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("旅游地图")
                      }
                    }
                  },
                  [_vm._v("\n        旅游地图\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "alltitle" }, [_vm._v("小区")]),
          _vm._v(" "),
          _vm.$store.state.Counter.city === "杭州"
            ? _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("小区入驻审核")
                      }
                    }
                  },
                  [_vm._v("\n        小区入驻审核\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("小区区长设置")
                      }
                    }
                  },
                  [_vm._v("\n        小区区长设置\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("定位数据")
                      }
                    }
                  },
                  [_vm._v("\n        定位数据\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("投诉列表")
                      }
                    }
                  },
                  [_vm._v("\n        投诉列表\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/xjxqDataBoard")
                      }
                    }
                  },
                  [_vm._v("\n        数据看板\n      ")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "safety",
              expression: "current === 'safety'"
            }
          ],
          staticClass: "market"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("安全监控")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("留言审核")
                  }
                }
              },
              [_vm._v("\n        留言审核\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("内容审核")
                  }
                }
              },
              [_vm._v("\n        内容审核\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "content",
              expression: "current === 'content'"
            }
          ],
          staticClass: "content"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("内容小队")]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("问答以及智能化")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toGetOneDayTalk("内容")
                  }
                }
              },
              [_vm._v("\n        群聊记录\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.toCommentEstate }
              },
              [_vm._v("\n        楼盘点评\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/estateRateCount")
                  }
                }
              },
              [_vm._v("\n        楼盘评测统计表\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("最近留言")
                  }
                }
              },
              [_vm._v("\n        最近留言\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.gohousetype()
                  }
                }
              },
              [_vm._v("智能问答")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.goBuildingValuation }
              },
              [_vm._v("\n        楼盘评价\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.godownSideValuation }
              },
              [_vm._v("\n        楼盘不利于有利评价\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/checkAIAns")
                  }
                }
              },
              [_vm._v("\n        AI问答结果评判\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/intelligentHouse")
                  }
                }
              },
              [_vm._v("\n        智能助手标注\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/intelligenceArticle")
                  }
                }
              },
              [_vm._v("\n        智能文章助手\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("智能媒体")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("智能评价")
                  }
                }
              },
              [_vm._v("\n        智能评价\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("智能标题")
                  }
                }
              },
              [_vm._v("\n        智能标题\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/intelligenceSelectTopic")
                  }
                }
              },
              [_vm._v("\n        智能选题\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/voiceClone")
                  }
                }
              },
              [_vm._v("\n        克隆声音\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/articleAdapt")
                  }
                }
              },
              [_vm._v("\n        文章改进与重编\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("楼盘评测视频")
                  }
                }
              },
              [_vm._v("\n        楼盘评测视频\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("楼盘评测文章")
                  }
                }
              },
              [_vm._v("\n        楼盘评测文章\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/shanghai/articleManage" })
                  }
                }
              },
              [_vm._v("\n        文章管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("智能话题管理")
                  }
                }
              },
              [_vm._v("\n        智能话题管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/houseSelectService" })
                  }
                }
              },
              [_vm._v("\n        选房服务后台\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/estateTagManage" })
                  }
                }
              },
              [_vm._v("\n        楼盘标签\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/featuredListings" })
                  }
                }
              },
              [_vm._v("\n        精选房源\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("楼盘分类")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getApartList()
                  }
                }
              },
              [_vm._v("4室户型")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getOldPrice()
                  }
                }
              },
              [_vm._v("\n        2-3万楼盘\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getHouse()
                  }
                }
              },
              [_vm._v("90方楼盘")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("楼盘动态")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEstateGS("正在公示")
                  }
                }
              },
              [_vm._v("\n        正在公示表格\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEstateGS("正在登记")
                  }
                }
              },
              [_vm._v("\n        正在登记表格\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEstateText("正在公示")
                  }
                }
              },
              [_vm._v("\n        正在公示文本\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEstateText("正在登记")
                  }
                }
              },
              [_vm._v("\n        正在登记文本\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "normal cibutton", on: { click: _vm.showNews } },
              [_vm._v("最新政府文章")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.getEstateRate }
              },
              [_vm._v("近期摇号")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEstateZJ()
                  }
                }
              },
              [_vm._v("总价楼盘")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getyuji()
                  }
                }
              },
              [_vm._v("\n        预计开盘excel/sale\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getHzTitle()
                  }
                }
              },
              [_vm._v("杭州公示")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getZJRecent()
                  }
                }
              },
              [_vm._v("中签率")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("楼盘周边")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.onNearbyClick }
              },
              [_vm._v("附近地图")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("板块")
                  }
                }
              },
              [_vm._v("\n        板块图\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("控规")
                  }
                }
              },
              [_vm._v("\n        板块规划\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("板块规划")
                  }
                }
              },
              [_vm._v("\n        控规图\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("高架")
                  }
                }
              },
              [_vm._v("\n        快速路\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("板块热力")
                  }
                }
              },
              [_vm._v("\n        热力图\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toMapPage("地铁图")
                  }
                }
              },
              [_vm._v("\n        地铁图\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.checkEstateImageNum }
              },
              [_vm._v("\n        楼盘图片视频数量\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("干货地图")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cibuttonwarp" },
            [
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("新房", "全城左")
                    }
                  }
                },
                [_vm._v("\n        新房左\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("新房", "全城右")
                    }
                  }
                },
                [_vm._v("\n        新房右\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("新房", "全城")
                    }
                  }
                },
                [_vm._v("\n        新房整\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("待首开", "全城左")
                    }
                  }
                },
                [_vm._v("\n        待首开和土拍左\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("待首开", "全城右")
                    }
                  }
                },
                [_vm._v("\n        待首开和土拍右\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("待首开", "全城")
                    }
                  }
                },
                [_vm._v("\n        待首开和土拍整\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("土拍", "全城左")
                    }
                  }
                },
                [_vm._v("\n        土拍左\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("土拍", "全城右")
                    }
                  }
                },
                [_vm._v("\n        土拍右\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("土拍", "全城")
                    }
                  }
                },
                [_vm._v("\n        土拍整\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("土拍圆点", "全城左")
                    }
                  }
                },
                [_vm._v("\n        土拍圆点左\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("土拍圆点", "全城右")
                    }
                  }
                },
                [_vm._v("\n        土拍圆点右\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("土拍圆点", "全城")
                    }
                  }
                },
                [_vm._v("\n        土拍圆点整\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("公示登记", "全城左")
                    }
                  }
                },
                [_vm._v("\n        公示登记左\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("公示登记", "全城右")
                    }
                  }
                },
                [_vm._v("\n        公示登记右\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("公示登记", "全城")
                    }
                  }
                },
                [_vm._v("\n        公示登记整\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "normal cibutton",
                  on: {
                    click: function($event) {
                      return _vm.toMapPage("科创大走廊")
                    }
                  }
                },
                [_vm._v("\n        科创大走廊\n      ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.areaArr, function(area) {
                return _c(
                  "button",
                  {
                    key: area,
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toMapPage("新房", area)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(area) + "\n      ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("房产政策")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/propertyPolicy")
                  }
                }
              },
              [_vm._v("\n        房产政策数据库\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("二手房")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/areaTwoHouseMoonDeal")
                  }
                }
              },
              [_vm._v("\n        区域月成交\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/schoolTwoHouseDeal")
                  }
                }
              },
              [_vm._v("\n        学区成交查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/areaTwoHouseHighestDeal")
                  }
                }
              },
              [_vm._v("\n        区域成交榜单\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/beikeSechandHouse")
                  }
                }
              },
              [_vm._v("\n        贝壳二手房数据查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.drawPoster2(1)
                  }
                }
              },
              [_vm._v("\n        每日早报(成交)\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.drawPoster2(2)
                  }
                }
              },
              [_vm._v("\n        每日早报(挂牌)\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/secondDistrictSale")
                  }
                }
              },
              [_vm._v("\n        区域二手房成交/挂牌查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/secondSchoolSale")
                  }
                }
              },
              [_vm._v("\n        学区二手房成交/挂牌查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/secondSubwaySale")
                  }
                }
              },
              [_vm._v("\n        地铁二手房成交/挂牌查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/areanameDataSummary")
                  }
                }
              },
              [_vm._v("\n        板块数据概括查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/schoolDataSummary")
                  }
                }
              },
              [_vm._v("\n        学区数据概括查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/EstateHousesSearch")
                  }
                }
              },
              [_vm._v("\n        在售楼盘查询\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/priceChangeAnalysis")
                  }
                }
              },
              [_vm._v("\n        涨价降价房源筛选\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/newHouseFilter")
                  }
                }
              },
              [_vm._v("\n        新房楼盘筛选\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("其他")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getGongZong()
                  }
                }
              },
              [_vm._v("\n        公众号消息通知\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getHotingList()
                  }
                }
              },
              [_vm._v("\n        生命周期\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getEstateSort()
                  }
                }
              },
              [_vm._v("\n        近期排行\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                staticStyle: { overflow: "hidden", position: "relative" }
              },
              [
                _vm._v("\n        图片拼接\n        "),
                _c("input", {
                  attrs: { type: "file", multiple: "", id: "input_image" },
                  on: { change: _vm.combineImg }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.getVisitData }
              },
              [_vm._v("访问链接")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.toServiceReply }
              },
              [_vm._v("\n        服务号回复\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("公众号管理")
                  }
                }
              },
              [_vm._v("\n        公众号管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("导入小程序数据")
                  }
                }
              },
              [_vm._v("\n        导入小程序数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("行情评论")
                  }
                }
              },
              [_vm._v("\n        行情评论\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/estateAIAnalysis" })
                  }
                }
              },
              [_vm._v("\n        楼盘AI分析数据\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/bigScreenMapDisplay" })
                  }
                }
              },
              [_vm._v("\n        大屏幕地图展示\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "data",
              expression: "current === 'data'"
            }
          ],
          staticClass: "data"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("数据小队")]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "cititle" }, [_vm._v("猩号")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getPoiIformation()
                      }
                    }
                  },
                  [_vm._v("\n          筛选猩号空间\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toOpinion()
                      }
                    }
                  },
                  [_vm._v("\n          猩号意见反馈\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("猩号空间管理")
                      }
                    }
                  },
                  [_vm._v("\n          猩号空间管理\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.gefinished()
                      }
                    }
                  },
                  [_vm._v("\n          筛选工作完成度表\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/couponManage")
                      }
                    }
                  },
                  [_vm._v("\n          特惠项目管理\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("评测类工具")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.houseTypeTools()
                      }
                    }
                  },
                  [_vm._v("\n          户型工具\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toMapPage("控规")
                      }
                    }
                  },
                  [_vm._v("\n          板块规划\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toMapPage("板块规划")
                      }
                    }
                  },
                  [_vm._v("\n          控规图\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toHangPai()
                      }
                    }
                  },
                  [_vm._v("航拍管理")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.ToaerialSurvey()
                      }
                    }
                  },
                  [_vm._v("\n          航拍排查\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toPoiManage()
                      }
                    }
                  },
                  [_vm._v("\n          POI管理\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("问答类工具")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toTestReply }
                  },
                  [_vm._v("\n          测试自动回复\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.questionSituation()
                      }
                    }
                  },
                  [_vm._v("\n          智能问答匹配情况\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toGetOneDayTalk("数据")
                      }
                    }
                  },
                  [_vm._v("\n          群聊记录\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("自动问答")
                      }
                    }
                  },
                  [_vm._v("\n          自动问答管理\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getStatisticalTable("tjList")
                      }
                    }
                  },
                  [_vm._v("\n          匹配统计表格\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.checkMatchRecord()
                      }
                    }
                  },
                  [_vm._v("\n          问答匹配审核\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.chooseQuse()
                      }
                    }
                  },
                  [_vm._v("\n          判断问答是否为广告\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.totalAd()
                      }
                    }
                  },
                  [_vm._v("\n          问答广告统计表\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.changeListName("checkAutoReply")
                      }
                    }
                  },
                  [_vm._v("\n          检查回答\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/checkAIAns")
                      }
                    }
                  },
                  [_vm._v("\n          AI问答结果评判\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/terminology")
                      }
                    }
                  },
                  [_vm._v("\n          专业词汇编辑\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/SearchCheck")
                      }
                    }
                  },
                  [_vm._v("\n          搜索结果标注\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/messageStatic")
                      }
                    }
                  },
                  [_vm._v("\n          智能助手消息统计\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/intelligentHouse")
                      }
                    }
                  },
                  [_vm._v("\n          智能助手标注\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("统计类工具")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getPcList("pcList")
                      }
                    }
                  },
                  [_vm._v("\n          评测合计数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getPcList("ptList")
                      }
                    }
                  },
                  [_vm._v("\n          配套合计数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getNewPcList()
                      }
                    }
                  },
                  [_vm._v("\n          评测总和\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getshuju()
                      }
                    }
                  },
                  [_vm._v("数据系统")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/newHouseExtent")
                      }
                    }
                  },
                  [_vm._v("\n          新房专业完整度\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/twoHouseExtent")
                      }
                    }
                  },
                  [_vm._v("\n          二手房专业完整度\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.createAccout()
                      }
                    }
                  },
                  [_vm._v("\n          开发商账号管理\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.tohouseUploadData()
                      }
                    }
                  },
                  [_vm._v("\n          新增图片视频数量\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("土拍")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cibuttonwarp" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "normal cibutton",
                      attrs: { loading: _vm.candidateLoading },
                      on: { click: _vm.openCreateBatch }
                    },
                    [_vm._v("\n          新建土拍批次\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.landStatusState,
                          expression: "landStatusState"
                        }
                      ],
                      attrs: { name: "", id: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.landStatusState = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "待出让" } }, [
                        _vm._v("待出让")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "已出让" } }, [
                        _vm._v("已出让")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.landStatusBatch,
                        expression: "landStatusBatch"
                      }
                    ],
                    attrs: { type: "text", placeholder: "第几批" },
                    domProps: { value: _vm.landStatusBatch },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.landStatusBatch = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.changeLandStatus()
                        }
                      }
                    },
                    [_vm._v("\n          更改\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "新建土拍批次",
                    visible: _vm.batchDialogVisible,
                    width: "850px",
                    "close-on-click-modal": false,
                    "close-on-press-escape": !_vm.batchSubmitting,
                    "show-close": !_vm.batchSubmitting
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.batchDialogVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-width": "90px" },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "批次名称" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "50",
                              disabled: _vm.batchSubmitting
                            },
                            model: {
                              value: _vm.batchName,
                              callback: function($$v) {
                                _vm.batchName = $$v
                              },
                              expression: "batchName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "仅显示今天录入且未归批次的地块，默认全选，可取消勾选。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "candidateTable",
                      attrs: {
                        data: _vm.batchCandidates,
                        "row-key": "id",
                        border: ""
                      },
                      on: {
                        "selection-change": function($event) {
                          _vm.selectedLands = $event
                        }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "50",
                          selectable: function() {
                            return !_vm.batchSubmitting
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "number",
                          label: "宗地编号",
                          width: "200"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "地块名称" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "district", label: "区域", width: "90" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "已选 " +
                        _vm._s(_vm.selectedLands.length) +
                        " 个地块。创建后立即展示，楼盘和评分后台处理，结果会发送到钉钉信息监控群。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: _vm.batchSubmitting },
                          on: {
                            click: function($event) {
                              _vm.batchDialogVisible = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.batchSubmitting,
                            disabled:
                              !_vm.batchName.trim() || !_vm.selectedLands.length
                          },
                          on: { click: _vm.createBatch }
                        },
                        [_vm._v("创建并后台处理")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("商铺")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.createStore()
                      }
                    }
                  },
                  [_vm._v("\n          商铺编辑\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toStoreLocation()
                      }
                    }
                  },
                  [_vm._v("\n          商铺周边位置编辑\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toStorePeopleLocation()
                      }
                    }
                  },
                  [_vm._v("\n          商铺人流量位置编辑\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toStoreHX()
                      }
                    }
                  },
                  [_vm._v("\n          商铺户型图编辑\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toDrawStore()
                      }
                    }
                  },
                  [_vm._v("画商铺")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("二手房")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.toMatchEstateName(true)
                      }
                    }
                  },
                  [_vm._v("\n          楼盘名称待匹配\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getEstateNameMatchList()
                      }
                    }
                  },
                  [_vm._v("\n          楼盘名称已匹配\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/deleteEstate")
                      }
                    }
                  },
                  [_vm._v("\n          删除二手楼盘\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/estateDealData")
                      }
                    }
                  },
                  [_vm._v("\n          二手成交上传\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/agentUploadData")
                      }
                    }
                  },
                  [_vm._v("\n          经纪人上传图片视频数量\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("审核")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cibuttonwarp" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("新房图片审核")
                        }
                      }
                    },
                    [_vm._v("\n          图片视频审核\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("上传楼盘详情审核")
                        }
                      }
                    },
                    [_vm._v("\n          上传楼盘详情审核\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("新增配套审核")
                        }
                      }
                    },
                    [_vm._v("\n          新增配套审核\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-badge",
                    {
                      staticClass: "red-point-item",
                      attrs: { "is-dot": _vm.pointData.hasInfoFeedbackAudit }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "cibutton",
                          on: {
                            click: function($event) {
                              return _vm.toEstateImportDataModify()
                            }
                          }
                        },
                        [_vm._v("\n            楼盘重磅资料审核\n          ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.onPageClick("置业顾问管理")
                        }
                      }
                    },
                    [_vm._v("\n          置业顾问管理\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.routerPushTo("/communityFacilityAudit")
                        }
                      }
                    },
                    [_vm._v("\n          小区设施审核\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("其他")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.searchGsReal()
                      }
                    }
                  },
                  [_vm._v("\n          追踪公示楼盘数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getSellList()
                      }
                    }
                  },
                  [_vm._v("\n          2020后公示数据\n        ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "苏州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.szYuShouList()
                          }
                        }
                      },
                      [_vm._v("\n          预售证楼盘\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "苏州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.matchAdvance()
                          }
                        }
                      },
                      [_vm._v("\n          更新预售证\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        _vm.listName = "updataImage"
                      }
                    }
                  },
                  [_vm._v("\n          更新截图\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: { click: _vm.toEstateAsManage }
                  },
                  [_vm._v("\n          楼盘别名管理\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.onPageClick("拆迁地图数据")
                      }
                    }
                  },
                  [_vm._v("\n          拆迁地图数据\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    attrs: { disabled: _vm.isLoading },
                    on: { click: _vm.showGFTnotice }
                  },
                  [
                    _vm.isLoading
                      ? _c("span", [_vm._v("加载中...")])
                      : _c("span", [_vm._v("购房通公示")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.queryAllFreePrice()
                      }
                    }
                  },
                  [_vm._v("\n          一房一价绑定\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "/infoOfflineManage" })
                      }
                    }
                  },
                  [_vm._v("\n          信息下架管理\n        ")]
                ),
                _vm._v(" "),
                _vm.$store.state.Counter.city === "杭州"
                  ? _c(
                      "button",
                      {
                        staticClass: "normal cibutton",
                        on: {
                          click: function($event) {
                            return _vm.onPageClick("成交数据")
                          }
                        }
                      },
                      [_vm._v("\n          成交数据\n        ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px" },
                        attrs: { size: "small" },
                        model: {
                          value: _vm.type,
                          callback: function($$v) {
                            _vm.type = $$v
                          },
                          expression: "type"
                        }
                      },
                      [
                        _c("el-option", { attrs: { value: "新房" } }, [
                          _vm._v("新房")
                        ]),
                        _vm._v(" "),
                        _c("el-option", { attrs: { value: "二手房" } }, [
                          _vm._v("二手房")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px", "margin-left": "5px" },
                        attrs: { size: "small" },
                        model: {
                          value: _vm.value,
                          callback: function($$v) {
                            _vm.value = $$v
                          },
                          expression: "value"
                        }
                      },
                      [
                        _c("el-option", { attrs: { value: "日照" } }, [
                          _vm._v("日照")
                        ]),
                        _vm._v(" "),
                        _c("el-option", { attrs: { value: "户型" } }, [
                          _vm._v("户型")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        size: "small",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期"
                      },
                      model: {
                        value: _vm.checkDate1,
                        callback: function($$v) {
                          _vm.checkDate1 = $$v
                        },
                        expression: "checkDate1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getSunHouse("详情")
                      }
                    }
                  },
                  [_vm._v("\n          查询\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "div",
                  { staticClass: "add-margin" },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        size: "small",
                        type: "daterange",
                        align: "right",
                        "unlink-panels": "",
                        "value-format": "yyyy-MM-dd",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.value1,
                        callback: function($$v) {
                          _vm.value1 = $$v
                        },
                        expression: "value1"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.getSunHouse("统计")
                      }
                    }
                  },
                  [_vm._v("\n          统计近期上传数据\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("产业评测")]),
              _vm._v(" "),
              _c("div", { staticClass: "cibuttonwarp" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "add-margin",
                        staticStyle: { width: "100px" },
                        attrs: { size: "small" },
                        on: { change: _vm.changeValueMap },
                        model: {
                          value: _vm.valueBigType,
                          callback: function($$v) {
                            _vm.valueBigType = $$v
                          },
                          expression: "valueBigType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "楼盘", value: "estate" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "板块", value: "area" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticClass: "add-margin",
                        staticStyle: { width: "100px" },
                        attrs: { size: "small", placeholder: "选择类别" },
                        model: {
                          value: _vm.valueType,
                          callback: function($$v) {
                            _vm.valueType = $$v
                          },
                          expression: "valueType"
                        }
                      },
                      _vm._l(_vm.valueMap, function(value, key) {
                        return _c("el-option", {
                          key: key,
                          attrs: { label: value, value: key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.updateEstateValue("sort")
                      }
                    }
                  },
                  [_vm._v("\n          查看产业排序\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.goEstateValueMap(_vm.valueType)
                      }
                    }
                  },
                  [_vm._v("\n          查看产业地图\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.updateEstateValue("count")
                      }
                    }
                  },
                  [_vm._v("\n          更新产业计算\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.updateEstateValue("score")
                      }
                    }
                  },
                  [_vm._v("\n          更新产业分\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cititle" }, [_vm._v("其它评测")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cibuttonwarp" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "add-margin",
                      staticStyle: { width: "100px" },
                      attrs: { size: "small" },
                      model: {
                        value: _vm.valueOtherType,
                        callback: function($$v) {
                          _vm.valueOtherType = $$v
                        },
                        expression: "valueOtherType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "配套", value: "配套" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "规划", value: "规划" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "配套密度", value: "配套密度" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.valueOtherType == "配套"
                    ? _c(
                        "el-select",
                        {
                          staticClass: "add-margin",
                          staticStyle: { width: "100px" },
                          attrs: { size: "small", placeholder: "选择类别" },
                          model: {
                            value: _vm.locationType,
                            callback: function($$v) {
                              _vm.locationType = $$v
                            },
                            expression: "locationType"
                          }
                        },
                        _vm._l(_vm.locationMap, function(value, key) {
                          return _c("el-option", {
                            key: key,
                            attrs: { label: value, value: key }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.getOtherValueScore(_vm.valueOtherType)
                        }
                      }
                    },
                    [_vm._v("\n          查看排序\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.goEstateValueMap("", _vm.valueOtherType)
                        }
                      }
                    },
                    [_vm._v("\n          查看地图\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.goEstateValueMap("", "安置房")
                        }
                      }
                    },
                    [_vm._v("\n          安置房地图\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "normal cibutton",
                      on: {
                        click: function($event) {
                          return _vm.routerPushTo("/sunshineEvaluation")
                        }
                      }
                    },
                    [_vm._v("\n          日照评测\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "innovate",
              expression: "current === 'innovate'"
            }
          ],
          staticClass: "innovate"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("创新小队")]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("全部功能")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c("div", { staticClass: "add-margin" }, [
              _vm._v("小程序图标上传")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-margin" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.imageName,
                    expression: "imageName"
                  }
                ],
                attrs: {
                  type: "text",
                  size: "small",
                  placeholder: "图片名称, 不要后缀"
                },
                domProps: { value: _vm.imageName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.imageName = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-margin" }, [
              _c("input", {
                attrs: { type: "file", size: "small" },
                on: { change: _vm.chooseImage }
              })
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.imageSrc))]),
            _vm._v(" "),
            _vm.userType === "系统管理员"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.$router.push({ path: "employee" })
                      }
                    }
                  },
                  [_vm._v("\n        后台账号管理\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "normal cibutton", on: { click: _vm.checkErp } },
              [_vm._v("checkErp")]
            ),
            _vm._v(" "),
            _vm.userType === "系统管理员"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.switchTimedTask("定时任务")
                      }
                    }
                  },
                  [_vm._v("\n        开关定时任务\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.switchTimedTask("用户校验")
                  }
                }
              },
              [_vm._v("\n        开关用户校验\n      ")]
            ),
            _vm._v(" "),
            _vm.userType === "系统管理员"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.switchTimedTask("实时加分")
                      }
                    }
                  },
                  [_vm._v("\n        开关实时加分\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userType === "系统管理员"
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.switchTimedTask("房源视频")
                      }
                    }
                  },
                  [_vm._v("\n        开关房源视频\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.checkOldSpider }
              },
              [_vm._v("\n        二手房爬虫\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getMoments()
                  }
                }
              },
              [_vm._v("\n        加分失败打印\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "normal cibutton", on: { click: _vm.getLogs } },
              [_vm._v("小鸡错误日志")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toGetUpdataApp()
                  }
                }
              },
              [_vm._v("\n        猩号app版本更新\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getXHLogs()
                  }
                }
              },
              [_vm._v("\n        猩号错误日志\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.toTestReply }
              },
              [_vm._v("\n        测试自动回复\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.selcectCheWei }
              },
              [_vm._v("\n        车位材料判断\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "normal cibutton", on: { click: _vm.toEmoticon } },
              [_vm._v("\n        猩号表情管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: "/xiaojiEmoji" })
                  }
                }
              },
              [_vm._v("\n        小鸡表情管理\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.toChoosePriceFile }
              },
              [_vm._v("\n        更新二手均价\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/wechatMiniProgramDataTrend")
                  }
                }
              },
              [_vm._v("\n        小程序数据趋势\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/versionTips")
                  }
                }
              },
              [_vm._v("\n        版本更新说明\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("其他")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "div",
              { staticClass: "add-margin" },
              [
                _c("el-date-picker", {
                  attrs: {
                    size: "small",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    placeholder: "选择日期"
                  },
                  model: {
                    value: _vm.checkDate2,
                    callback: function($$v) {
                      _vm.checkDate2 = $$v
                    },
                    expression: "checkDate2"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.showPageHits("首页")
                  }
                }
              },
              [_vm._v("\n        新房首页点击数\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.showPageHits("楼盘页面")
                  }
                }
              },
              [_vm._v("\n        新房楼盘页点击数\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.showPageHits("二手房首页")
                  }
                }
              },
              [_vm._v("\n        二手房首页点击数\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.showPageHits("二手楼盘首页")
                  }
                }
              },
              [_vm._v("\n        二手房楼盘页点击数\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "normal cibutton", on: { click: _vm.talkNum } },
              [_vm._v("群互动")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: { click: _vm.getRedEvbag }
              },
              [_vm._v("红包")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getchuangxin()
                  }
                }
              },
              [_vm._v("\n        数据系统\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.onPageClick("猩号炒群")
                  }
                }
              },
              [_vm._v("\n        猩号炒群\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.getDataInfo()
                  }
                }
              },
              [_vm._v("数据面板")]
            ),
            _vm._v(" "),
            _vm.canViewPerformanceMonitor
              ? _c(
                  "button",
                  {
                    staticClass: "normal cibutton",
                    on: {
                      click: function($event) {
                        return _vm.routerPushTo("/performance-monitor")
                      }
                    }
                  },
                  [_vm._v("\n        性能监控\n      ")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("家电")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toNewGoods()
                  }
                }
              },
              [_vm._v("新建商品")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.toGoodsShow()
                  }
                }
              },
              [_vm._v("商品展示")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/businessIfoUpload")
                  }
                }
              },
              [_vm._v("\n        商家信息上传\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/businessInfoshow")
                  }
                }
              },
              [_vm._v("\n        商家信息展示\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cititle" }, [_vm._v("装修")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/renovationManage")
                  }
                }
              },
              [_vm._v("\n        装修品牌及活动管理\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "authority",
              expression: "current === 'authority'"
            }
          ],
          staticClass: "authority"
        },
        [_c("h3", { staticClass: "normal" }, [_vm._v("内部权限")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.current === "feedback",
              expression: "current === 'feedback'"
            }
          ],
          staticClass: "market"
        },
        [
          _c("h3", { staticClass: "normal" }, [_vm._v("意见反馈")]),
          _vm._v(" "),
          _c("div", { staticClass: "cibuttonwarp" }, [
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/feedbackQuestion")
                  }
                }
              },
              [_vm._v("\n        意见反馈\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "normal cibutton",
                on: {
                  click: function($event) {
                    return _vm.routerPushTo("/feedbackCount")
                  }
                }
              },
              [_vm._v("\n        意见统计\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showZxTable
        ? _c(
            "div",
            { staticStyle: { "max-width": "500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("装修推广数据")]
              ),
              _vm._v(" "),
              _c("el-date-picker", {
                staticStyle: { margin: "20px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "value-format": "yyyy-MM-dd",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                },
                model: {
                  value: _vm.zxDataTime,
                  callback: function($$v) {
                    _vm.zxDataTime = $$v
                  },
                  expression: "zxDataTime"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: {
                    click: function($event) {
                      return _vm.getZXData()
                    }
                  }
                },
                [_vm._v("\n      搜索\n    ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.zxData, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "100px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "new_pv", label: "新房首页按钮曝光" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "second_pv", label: "二手房首页按钮曝光" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "new_ad_exposure",
                      label: "新房首页贴片曝光"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "second_ad_exposure",
                      label: "二手房首页贴片曝光"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showZxConsult
        ? _c(
            "div",
            { staticStyle: { "max-width": "500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("\n      装修推广的电话量和咨询量统计数据\n    ")]
              ),
              _vm._v(" "),
              _c("el-date-picker", {
                staticStyle: { margin: "20px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "value-format": "yyyy-MM-dd",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                },
                model: {
                  value: _vm.zxConsultTime,
                  callback: function($$v) {
                    _vm.zxConsultTime = $$v
                  },
                  expression: "zxConsultTime"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: {
                    click: function($event) {
                      return _vm.getZXConsult()
                    }
                  }
                },
                [_vm._v("\n      搜索\n    ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.zxConsult, border: "", stripe: "" },
                  on: { "cell-click": _vm.modifyZXData }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "100px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "电话" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "talk", label: "咨询" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSale,
              expression: "showSale"
            }
          ],
          staticStyle: { "max-width": "680px", margin: "50px auto" }
        },
        [
          _c(
            "h2",
            { staticStyle: { "text-align": "center", margin: "20px 0" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.checkDate1) +
                  _vm._s(_vm.listName == "shareTop" ? "销售" : "经纪人") +
                  "分享排名\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.listName == "shareTop"
            ? _c(
                "el-select",
                {
                  model: {
                    value: _vm.areaValue,
                    callback: function($$v) {
                      _vm.areaValue = $$v
                    },
                    expression: "areaValue"
                  }
                },
                _vm._l(_vm.areaFilterList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.listName == "shareTop"
            ? _c(
                "el-select",
                {
                  on: {
                    change: function($event) {
                      return _vm.getShareTop(
                        "销售",
                        _vm.areaValue,
                        _vm.scoreType
                      )
                    }
                  },
                  model: {
                    value: _vm.scoreType,
                    callback: function($$v) {
                      _vm.scoreType = $$v
                    },
                    expression: "scoreType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "邀请用户得分", value: null }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "仅签到得分", value: "仅签到得分" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "转发文章得分", value: "转发文章得分" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", icon: "el-icon-search" },
              on: {
                click: function($event) {
                  return _vm.getShareTop("销售", _vm.areaValue, _vm.scoreType)
                }
              }
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _vm.shareTop.length > 0 &&
          (_vm.listName == "shareTop" || _vm.listName == "shareTop2")
            ? _c(
                "el-table",
                { attrs: { data: _vm.shareTop, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "index", label: "排名", width: "50" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "district",
                      label: "区域",
                      filters: _vm.district,
                      "filter-method": _vm.filterHandler
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "total",
                      label: _vm.scoreType || "邀请用户得分",
                      width: "150"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    !_vm.scoreType
                                      ? row.total
                                      : _vm.scoreType == "仅签到得分"
                                      ? row.detail[row.time.split(" ")[0]].qd
                                      : row.detail[row.time.split(" ")[0]]
                                          .article
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1906209996
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "time", label: "时间", width: "160" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.sharePublic.length > 0 && _vm.listName == "sharePublic"
        ? _c(
            "div",
            { staticStyle: { "max-width": "332px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("合作公众号分享数据")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.sharePublic, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名", width: "150" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "point", label: "分享次数", width: "180" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "shareTop3"
        ? _c(
            "div",
            { staticStyle: { "max-width": "700px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.checkDate1) + "销售群聊违规\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.shareTop, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "create_time",
                      label: "消息时间",
                      width: "140px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名", width: "80px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "chat_name", label: "群名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "content", label: "违规内容" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shareWeekTop.length > 0 && _vm.listName == "shareWeekTop"
        ? _c(
            "div",
            { staticStyle: { "max-width": "580px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("销售上周分享分排名")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.shareWeekTop, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "index", label: "排名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "lastWeeks", label: "总积分(上周)" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.articleShares.length > 0 && _vm.listName == "articleShares"
        ? _c(
            "div",
            { staticStyle: { "max-width": "580px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("文章分享排名")]
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.articleTitle))]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.articleShares, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "index", label: "排名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "邀请人数" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.bindPriceList.length > 0 && _vm.listName == "bindPriceList"
        ? _c(
            "div",
            { staticStyle: { width: "700px", margin: "50px auto" } },
            [
              _c("h2", [_vm._v("一房一价绑定")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "搜索楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: ""
                  },
                  model: {
                    value: _vm.bindPriceEstateId,
                    callback: function($$v) {
                      _vm.bindPriceEstateId = $$v
                    },
                    expression: "bindPriceEstateId"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.bindPriceList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "number", label: "预售证" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "create_time", label: "时间" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toBindPriceEstate(
                                        scope.row,
                                        scope.$index
                                      )
                                    }
                                  }
                                },
                                [_vm._v("绑定")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2825478476
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.GsList.length > 0 && _vm.listName == "GsList"
        ? _c(
            "div",
            { staticStyle: { width: "700px", margin: "50px auto" } },
            _vm._l(_vm.GsList, function(item) {
              return _c(
                "div",
                { key: item.id, staticStyle: { margin: "20px 0" } },
                [
                  _c("h2", [_vm._v(_vm._s(item.state))]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: item.list, border: "", stripe: "" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "real_estate_name",
                          label: "楼盘名",
                          width: "130px"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "hasSun", label: "日照评测" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "hasApart", label: "户型评测" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "hasEffect", label: "楼栋评测" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "hasPrice", label: "一房一价" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "hasNoise", label: "噪音分析" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "意向", label: "意向登记" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "摇号", label: "摇号结果" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userList.length > 0 && _vm.listName == "userList"
        ? _c(
            "div",
            { staticStyle: { width: "520px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.filterUserList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "id", width: "110px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "名字", width: "130px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_type", label: "身份" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_status", label: "状态", width: "80px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.unStatus(
                                        scope.row,
                                        scope.$index
                                      )
                                    }
                                  }
                                },
                                [_vm._v("解禁")]
                              )
                            ]
                          }
                        },
                        {
                          key: "header",
                          fn: function(scope) {
                            return [
                              scope.column
                                ? _c("el-input", {
                                    attrs: {
                                      size: "mini",
                                      placeholder: "输入关键字搜索"
                                    },
                                    model: {
                                      value: _vm.userSearch,
                                      callback: function($$v) {
                                        _vm.userSearch = $$v
                                      },
                                      expression: "userSearch"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      229370054
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.interest.list && _vm.listName == "interest"
        ? _c(
            "div",
            [
              _c("h2", [_vm._v("编辑银行利率")]),
              _vm._v(" "),
              _c("div", { staticClass: "normal" }, [
                _vm._v("\n      更新时间："),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.interest.update_time,
                      expression: "interest.update_time"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.interest.update_time },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.interest, "update_time", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm._l(_vm.interest.list, function(bl, index) {
                return _c("div", { key: index }, [
                  _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("div", [
                      _vm._v("\n          银       行："),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: bl.bank,
                            expression: "bl.bank"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: bl.bank },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(bl, "bank", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n          首套利率："),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: bl.firstInterestRate,
                            expression: "bl.firstInterestRate"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: bl.firstInterestRate },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              bl,
                              "firstInterestRate",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("首套 LPR："),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: bl.firstLPR,
                            expression: "bl.firstLPR"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: bl.firstLPR },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(bl, "firstLPR", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n          二套利率："),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: bl.secondInterestRate,
                            expression: "bl.secondInterestRate"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: bl.secondInterestRate },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              bl,
                              "secondInterestRate",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "border-bottom": "1px solid #eee",
                          "padding-bottom": "10px"
                        }
                      },
                      [
                        _vm._v("\n          二套 LPR："),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: bl.secondLPR,
                              expression: "bl.secondLPR"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: bl.secondLPR },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(bl, "secondLPR", $event.target.value)
                            }
                          }
                        })
                      ]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toadd()
                    }
                  }
                },
                [_vm._v("添加")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.perserve()
                    }
                  }
                },
                [_vm._v("保存")]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "essay"
        ? _c("div", { staticStyle: { "margin-top": "40px" } }, [
            _vm.essay.length == 0
              ? _c("h2", [_vm._v("编辑合作公众号")])
              : _vm._e(),
            _vm._v(" "),
            _vm.essay.length != 0
              ? _c(
                  "div",
                  [
                    _c("h2", [_vm._v("编辑合作公众号")]),
                    _vm._v(" "),
                    _vm._l(_vm.essay, function(es, index) {
                      return _c("div", { key: index }, [
                        _c("div", { staticStyle: { margin: "20px 0" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.essay[index],
                                expression: "essay[index]"
                              }
                            ],
                            attrs: { type: "text" },
                            domProps: { value: _vm.essay[index] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.essay, index, $event.target.value)
                              }
                            }
                          })
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.toEssayAdd()
                      }
                    }
                  },
                  [_vm._v("添加")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.essayPerserve()
                      }
                    }
                  },
                  [_vm._v("保存")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.phoneUsers.length > 0 && _vm.listName == "phoneUsers"
        ? _c(
            "div",
            { staticStyle: { width: "520px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.phoneUsers, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "电话", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "from", label: "来源", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "create_time", label: "时间", width: "160" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.talkRecord.length > 0 && _vm.listName == "talkRecord"
        ? _c(
            "div",
            { staticStyle: { display: "inline-block", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.talkRecord, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dh", label: "被动电话", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "zx", label: "被动咨询", width: "100" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.yuyueList.length > 0 && _vm.listName == "yuyueList"
        ? _c(
            "div",
            { staticStyle: { width: "700px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.yuyueList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "create_time",
                      label: "时间",
                      width: "140px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "名字", width: "80px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "手机号", width: "100px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘",
                      width: "180px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "content", label: "联系" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newsList.length > 0 && _vm.listName == "newsList"
        ? _c(
            "div",
            { staticStyle: { width: "200px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.newsList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addList.length > 0 && _vm.listName == "addList"
        ? _c(
            "div",
            { staticStyle: { width: "400px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.addList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "时间" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num1", label: "销售动态" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num2", label: "小区内配套" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "getGongZong"
        ? _c("div", { staticStyle: { "margin-top": "40px" } }, [
            _vm.essay.length == 0 ? _c("h2", [_vm._v("编辑公众号")]) : _vm._e(),
            _vm._v(" "),
            _vm.essay.length != 0
              ? _c(
                  "div",
                  [
                    _c("h2", [_vm._v("编辑公众号")]),
                    _vm._v(" "),
                    _vm._l(_vm.essay, function(es, index) {
                      return _c("div", { key: index }, [
                        _c("div", { staticStyle: { margin: "20px 0" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.essay[index],
                                expression: "essay[index]"
                              }
                            ],
                            attrs: { type: "text" },
                            domProps: { value: _vm.essay[index] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(_vm.essay, index, $event.target.value)
                              }
                            }
                          })
                        ])
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.toEssayAdd()
                      }
                    }
                  },
                  [_vm._v("添加")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.essayGetGongZong()
                      }
                    }
                  },
                  [_vm._v("保存")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.checkSaleAd1.length > 0 && _vm.listName == "checkSaleAd1"
        ? _c(
            "div",
            { staticStyle: { "max-width": "880px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("销售展示位账单记录")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.checkSaleAd1,
                    border: "",
                    stripe: "",
                    "show-summary": "",
                    "summary-method": _vm.getSummaries
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "time", label: "时间", width: "160px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "operate", label: "操作", width: "80px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "销售名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘名",
                      width: "180px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "money", label: "金额", width: "70px" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "start_time",
                      label: "起始日",
                      width: "100px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "end_time", label: "结束日", width: "100px" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "seleceRZList"
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { margin: "20px 0" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      placeholder: "搜索楼盘",
                      "default-first-option": "",
                      "remote-method": _vm.searchEstate,
                      remote: ""
                    },
                    model: {
                      value: _vm.updataImage_text,
                      callback: function($$v) {
                        _vm.updataImage_text = $$v
                      },
                      expression: "updataImage_text"
                    }
                  },
                  _vm._l(_vm.matchEstates, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.real_estate_name, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "updataImage"
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticStyle: { margin: "20px 0" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "搜索楼盘",
                        "default-first-option": "",
                        "remote-method": _vm.searchEstate,
                        remote: ""
                      },
                      model: {
                        value: _vm.updataImage_text,
                        callback: function($$v) {
                          _vm.updataImage_text = $$v
                        },
                        expression: "updataImage_text"
                      }
                    },
                    _vm._l(_vm.matchEstates, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.real_estate_name + "(" + item.type + ")",
                          value: item.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { placeholder: "选择类别" },
                  model: {
                    value: _vm.updataImage_type,
                    callback: function($$v) {
                      _vm.updataImage_type = $$v
                    },
                    expression: "updataImage_type"
                  }
                },
                _vm._l(
                  [
                    {
                      value: "投资价值",
                      label: "投资价值"
                    },
                    {
                      value: "landplan",
                      label: "规划"
                    },
                    {
                      value: "location",
                      label: "配套"
                    },
                    {
                      value: "locationDensity",
                      label: "便民"
                    },
                    {
                      value: "area",
                      label: "板块"
                    },
                    {
                      value: "hxfb",
                      label: "户型分布"
                    },
                    {
                      value: "sun",
                      label: "日照"
                    },
                    {
                      value: "noise",
                      label: "噪声"
                    },
                    {
                      value: "jg3d",
                      label: "景观"
                    },
                    {
                      value: "people",
                      label: "人口热力图"
                    },
                    {
                      value: "store",
                      label: "周边商铺"
                    },
                    {
                      value: "industry",
                      label: "周边产业"
                    }
                  ],
                  function(type, index) {
                    return _c("el-option", {
                      key: index + "555",
                      attrs: { label: type.label, value: type.value }
                    })
                  }
                ),
                1
              ),
              _vm._v(" "),
              _c("button", { on: { click: _vm.updataImage_sure } }, [
                _vm._v("确定")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visitData.length > 0 && _vm.listName == "visitData"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1200px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("近7日访问")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "20px 0" } },
                [
                  _c(
                    "div",
                    { staticStyle: { margin: "20px 0" } },
                    [
                      _vm._v("\n        搜索楼盘id："),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchText,
                            expression: "searchText"
                          }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: {
                          type: "text",
                          placeholder: "输入楼盘名 回车搜索"
                        },
                        domProps: { value: _vm.searchText },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.searchReal.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchText = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.showdblist, function(item) {
                        return _c("div", { key: item.id }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.real_estate_name) +
                              "：" +
                              _vm._s(item.id) +
                              "\n        "
                          )
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.resultName === "个人空间"
                    ? _c("div", { staticStyle: { margin: "20px 0" } }, [
                        _vm._v("\n        填写顾问id："),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userId,
                              expression: "userId"
                            }
                          ],
                          staticStyle: { width: "200px" },
                          attrs: {
                            type: "text",
                            placeholder: "填写顾问的用户id"
                          },
                          domProps: { value: _vm.userId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.userId = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultName === "某个户型评测"
                    ? _c("div", { staticStyle: { margin: "20px 0" } }, [
                        _vm._v("\n        填写户型编号："),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.imgName2,
                              expression: "imgName2"
                            }
                          ],
                          staticStyle: { width: "200px" },
                          attrs: { type: "text", placeholder: "填写户型编号" },
                          domProps: { value: _vm.imgName2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.imgName2 = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showRealSearch
                    ? _c("div", { staticStyle: { margin: "20px 0" } }, [
                        _vm._v("\n        填写楼盘id："),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.valueRealId,
                              expression: "valueRealId"
                            }
                          ],
                          staticStyle: { width: "200px" },
                          attrs: { type: "text", placeholder: "填写楼盘id" },
                          domProps: { value: _vm.valueRealId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.valueRealId = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultName === "选日楼价"
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "选房" },
                          model: {
                            value: _vm.colType,
                            callback: function($$v) {
                              _vm.colType = $$v
                            },
                            expression: "colType"
                          }
                        },
                        _vm._l(
                          ["选房", "日照", "一房一价", "楼栋", "噪声"],
                          function(type) {
                            return _c("el-option", {
                              key: type,
                              attrs: { label: type, value: type }
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultName === "公示/登记/摇号/预计"
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "正在公示" },
                          model: {
                            value: _vm.shouyeType,
                            callback: function($$v) {
                              _vm.shouyeType = $$v
                            },
                            expression: "shouyeType"
                          }
                        },
                        _vm._l(
                          ["正在公示", "正在登记", "摇号查询", "预计开盘"],
                          function(type) {
                            return _c("el-option", {
                              key: type,
                              attrs: { label: type, value: type }
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultName === "买房/讨论/土拍/学区"
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "买房问答" },
                          model: {
                            value: _vm.tabbarStr,
                            callback: function($$v) {
                              _vm.tabbarStr = $$v
                            },
                            expression: "tabbarStr"
                          }
                        },
                        _vm._l(
                          ["买房问答", "楼市消息", "讨论", "土拍", "学区找房"],
                          function(type) {
                            return _c("el-option", {
                              key: type,
                              attrs: { label: type, value: type }
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getShareLoad }
                    },
                    [_vm._v("生成分享路径")]
                  ),
                  _vm._v(" "),
                  _vm.resultStr
                    ? _c("div", { staticStyle: { margin: "20px 0" } }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.resultName) +
                            "：" +
                            _vm._s(_vm.resultStr) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.visitData, border: "", stripe: "" },
                  on: {
                    "header-click": _vm.sortVisit,
                    "cell-click": _vm.findFX
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "page_name", label: "页面" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "share_path",
                      label: "分享路径",
                      width: "300"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "page_visit_pv", label: "访问次数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "page_visit_uv", label: "访问人数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "page_staytime_pv", label: "次均时长" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "entrypage_pv", label: "入口页次数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "exitpage_pv", label: "退出页次数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "exit_rate", label: "退出率" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "page_share_pv", label: "分享次数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "page_share_uv", label: "分享人数" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.estateImageNum.length > 0 && _vm.listName == "estateImageNum"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1450px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("楼盘图片视频数量")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.estateImageNum, border: "", stripe: "" },
                  on: { "header-click": _vm.sortImageNum }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "district",
                      label: "区域",
                      width: "70",
                      filters: _vm.filterDistrits,
                      "filter-method": _vm.filterEstate
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "area_name", label: "板块", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_status",
                      label: "状态",
                      width: "70",
                      filters: [
                        { text: "在售", value: "在售" },
                        { text: "待首开", value: "待首开" }
                      ],
                      "filter-method": _vm.filterEstate
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "build_type",
                      label: "类型",
                      width: "70",
                      filters: [
                        { text: "住宅", value: "住宅" },
                        { text: "商住", value: "商住" }
                      ],
                      "filter-method": _vm.filterEstate
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc", label: "区位配套", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "estate", label: "楼盘图", width: "70" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "apart", label: "户型图", width: "70" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "video", label: "视频", width: "50" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "ybf", label: "样板房视频", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "gw", label: "顾问人数", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "ybfvr", label: "样板房vr", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "hp", label: "航拍", width: "70" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dr", label: "达人点评", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "art", label: "小鸡文章", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "info", label: "详情", width: "70" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "active_num", label: "热度", width: "70" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.salerStatus.length > 0 && _vm.listName == "salerStatus"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1350px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("销售数据")]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  on: { change: _vm.showSalerStatus },
                  model: {
                    value: _vm.usUser,
                    callback: function($$v) {
                      _vm.usUser = $$v
                    },
                    expression: "usUser"
                  }
                },
                _vm._l(_vm.usUserList, function(type) {
                  return _c("el-option", {
                    key: type,
                    attrs: { label: type, value: type }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.salerStatus, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "day", label: "哪天" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "现有销售" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "new", label: "新增销售" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "activateNum", label: "活跃销售" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "signNum", label: "仅签到" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "shareWpNum", label: "分享小程序" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "shareArticleNum", label: "仅转发文章" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "top", label: "最高分" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "ave", label: "平均分" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "zero", label: "0分占比" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "fx", label: "分享进入" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "imgNum", label: "新增图片" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "audioNum", label: "新增语音" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "videoNum", label: "新增视频" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "chet", label: "聊天" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "kefu_talk", label: "客服" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.estatePageHits.length > 0 && _vm.listName == "estatePageHits"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("新房楼盘页点击")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.estatePageHits, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "一房一价", label: "一房一价" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "户型评测", label: "户型评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "配套地图", label: "配套评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "日照选房", label: "日照评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "噪声评测", label: "噪声评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "产业评测", label: "产业评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "规划评测", label: "规划评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "选房顺序", label: "选房顺序" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "楼栋分析", label: "楼栋评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "景观评测", label: "景观评测" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "楼盘问答", label: "买房问答" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "楼盘评价", label: "楼盘评价" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "VR航拍", label: "VR航拍" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "图库", label: "图库" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "楼盘详情", label: "详情" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "摇号记录", label: "摇号记录" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "智能匹配", label: "智能匹配" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "置业顾问", label: "置业顾问" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "业主群", label: "业主群" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "微信群", label: "微信群" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", { attrs: { prop: "pk", label: "PK" } })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.homePageHits.length > 0 && _vm.listName == "homePageHits"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("新房首页点击")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.homePageHits, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "正在公示", label: "正在公示", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "正在登记", label: "正在登记", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "摇号查询", label: "摇号查询", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "预计开盘", label: "预计开盘", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "特惠楼盘", label: "特惠楼盘", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "评测榜单", label: "评测榜单", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "日照评测", label: "日照评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "噪声评测", label: "噪声评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "户型评测", label: "户型评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "买房问答", label: "买房问答", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "地图找房", label: "地图找房", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "地铁找房", label: "地铁找房", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "学区找房", label: "学区找房", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "半径找房", label: "半径找房", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "评测合集", label: "评测合集", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "选房评测", label: "选房评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "倒挂评测", label: "倒挂评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "VR航拍评测",
                      label: "VR航拍评测",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "样板房评测",
                      label: "样板房评测",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "比价评测", label: "比价评测", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "配套评测", label: "配套评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "产业评测", label: "产业评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "3D户型评测",
                      label: "3D户型评测",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "景观评测", label: "景观评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "规划评测", label: "规划评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "评测文章", label: "评测文章", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "评测视频", label: "评测视频", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "土拍", label: "土拍评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "板块评测", label: "板块评测", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "百科政策", label: "政策百科", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "pk", label: "PK选房", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "公寓", label: "商业公寓", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "共有产权", label: "共有产权", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "3D车位", label: "3D车位", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "商铺", label: "商铺", width: "80" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.twoHomePageHits.length > 0 && _vm.listName == "twoHomePageHits"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1350px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("二手房首页点击")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.twoHomePageHits, border: "", stripe: "" }
                },
                _vm._l(_vm.secKeys, function(item) {
                  return _c("el-table-column", {
                    key: item,
                    attrs: {
                      prop: item,
                      label: item == "date" ? "日期" : item,
                      width: item == "date" ? "120" : ""
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.twoEstatePageHits.length > 0 && _vm.listName == "twoEstatePageHits"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1380px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("二手房楼盘页点击")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.twoEstatePageHits, border: "", stripe: "" }
                },
                _vm._l(_vm.secKeys, function(item) {
                  return _c("el-table-column", {
                    key: item,
                    attrs: {
                      prop: item,
                      label: item == "date" ? "日期" : item,
                      width: item == "date" ? "120" : ""
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.estateHits.length > 0 && _vm.listName == "estateHits"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("\n      " + _vm._s(_vm.checkDate1) + "楼盘点击\n    ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.estateHits, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "点击" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.msgNumList.length > 0 && _vm.listName == "msgNumList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.checkUserType) +
                      _vm._s(_vm.checkDate1) +
                      "咨询\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.msgNumList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_name",
                      label: "姓名（" + _vm.msgNumList.length + "）"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "咨询人数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSubstitute(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v("看聊天")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3648887347
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.estateScore.length > 0 && _vm.listName == "estateScore"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1080px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("配套评分")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.estateScore, border: "", stripe: "" },
                  on: { "header-click": _vm.sortEstate }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc_base.traffic", label: "交通" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc_base.market", label: "商场" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc_base.school", label: "学校" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc_base.hospital", label: "医院" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc_base.scenery", label: "景观" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "loc_base.public", label: "公建" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.estateRateList.length > 0 && _vm.listName == "estateRate"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1080px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("近期摇号")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.estateRateList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "give", label: "现房" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "advance", label: "预售证" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "register", label: "登记时间" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "district", label: "区域" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "price", label: "价格" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "house", label: "套数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "people", label: "人数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "rate", label: "中签率" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.advanceList.length > 0 && _vm.listName == "advanceList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1080px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("预售证信息")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.advanceList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "number", label: "预售证号" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "开发项目名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "company", label: "开发公司" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "location", label: "房屋坐落位置" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "purpose", label: "用途" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "核发日期" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "xHTalkTotal"
        ? _c(
            "div",
            [
              _c("div", [
                _c("h2", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("猩号话题发布统计")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        起始\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "起始日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.start_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "start_time", $$v)
                        },
                        expression: "ax.start_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        结束\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "结束日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.end_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "end_time", $$v)
                        },
                        expression: "ax.end_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("button", { on: { click: _vm.getXHTalkList } }, [
                  _vm._v("查询")
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "tableData",
                  staticStyle: { "max-width": "1000px", margin: "0 auto" },
                  attrs: {
                    data: _vm.xHTalkList,
                    "summary-method": _vm.sumList,
                    height: _vm.maxHeight,
                    border: "",
                    "show-summary": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "姓名",
                      "column-key": "name10",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.xHTalkListFilters.name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "label",
                      label: "类型",
                      "column-key": "label10",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.xHTalkListFilters.label
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "geo_name",
                      label: "空间",
                      "column-key": "geo_name10",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.xHTalkListFilters.geo_name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "数量", "column-key": "num10" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "date",
                      label: "时间",
                      "column-key": "date10"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "xHGSTotal"
        ? _c(
            "div",
            [
              _c("div", [
                _c("h2", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("猩号空间说灌水统计")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        起始\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "起始日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.start_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "start_time", $$v)
                        },
                        expression: "ax.start_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        结束\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "结束日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.end_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "end_time", $$v)
                        },
                        expression: "ax.end_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("button", { on: { click: _vm.getXHGSList } }, [
                  _vm._v("查询")
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "tableData1",
                  staticStyle: { "max-width": "1000px", margin: "0 auto" },
                  attrs: {
                    data: _vm.xHGSList,
                    height: _vm.maxHeight,
                    border: "",
                    "show-summary": "",
                    "summary-method": _vm.sumList
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "姓名",
                      "column-key": "name",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.xHGSListFilters.name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "geo_name",
                      label: "空间",
                      "column-key": "geo_name",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.xHGSListFilters.geo_name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "num",
                      label: "数量",
                      "column-key": "num",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "标题",
                      "column-key": "title"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "时间", "column-key": "date" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "groupWaterTable"
        ? _c(
            "div",
            [
              _c("div", [
                _c("h2", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("空间群灌水统计")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        起始\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "起始日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.start_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "start_time", $$v)
                        },
                        expression: "ax.start_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        结束\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "结束日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.end_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "end_time", $$v)
                        },
                        expression: "ax.end_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("button", { on: { click: _vm.getGroupWater } }, [
                  _vm._v("查询")
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "tableData2",
                  staticStyle: { "max-width": "1000px", margin: "0 auto" },
                  attrs: {
                    data: _vm.groupWaterList,
                    height: _vm.maxHeight,
                    border: "",
                    "show-summary": "",
                    "summary-method": _vm.sumList
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "姓名",
                      "column-key": "name",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.groupWaterFilter.name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "geo_name",
                      label: "空间",
                      "column-key": "geo_name",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.groupWaterFilter.geo_name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "num",
                      label: "数量",
                      "column-key": "num",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "group_name",
                      label: "群名",
                      "column-key": "title"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "时间", "column-key": "date" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "channelWaterTable"
        ? _c(
            "div",
            [
              _c("div", [
                _c("h2", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("频道灌水统计")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        起始\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "起始日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.start_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "start_time", $$v)
                        },
                        expression: "ax.start_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n        结束\n        "),
                    _c("el-date-picker", {
                      staticStyle: { width: "140px" },
                      attrs: {
                        type: "date",
                        placeholder: "结束日期",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.ax.end_time,
                        callback: function($$v) {
                          _vm.$set(_vm.ax, "end_time", $$v)
                        },
                        expression: "ax.end_time"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("button", { on: { click: _vm.getChannelWater } }, [
                  _vm._v("查询")
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "tableData3",
                  staticStyle: { "max-width": "1000px", margin: "0 auto" },
                  attrs: {
                    data: _vm.channelWaterList,
                    height: _vm.maxHeight,
                    border: "",
                    "show-summary": "",
                    "summary-method": _vm.sumList
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "姓名",
                      "column-key": "name",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.channelWaterFilter.name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "geo_name",
                      label: "空间",
                      "column-key": "geo_name",
                      "filter-method": _vm.filterEstate,
                      filters: _vm.channelWaterFilter.geo_name
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "num",
                      label: "数量",
                      "column-key": "num",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "channel_name",
                      label: "频道",
                      "column-key": "title"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "时间", "column-key": "date" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "yushouList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1180px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("苏州预售证")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.yushouList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "number", label: "预售证号" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "开发项目名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "company", label: "开发公司" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "location", label: "房屋坐落位置" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "purpose", label: "用途" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "核发日期" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "楼盘id", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("input", {
                                attrs: { type: "text" },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.matchOneAdvance(
                                      $event,
                                      scope.row.id
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.ignoreAdvance(scope.row.id)
                                    }
                                  }
                                },
                                [_vm._v("忽略")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      528166801
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.saleJoinData.length > 0 && _vm.listName == "saleJoinData"
        ? _c(
            "div",
            { staticStyle: { "max-width": "500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("近期入驻人数")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.saleJoinData, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sale", label: "置业顾问" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "agent", label: "经纪人" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.realInfoList.length > 0 &&
      (_vm.listName == "gsList" || _vm.listName == "djList")
        ? _c(
            "div",
            { staticStyle: { "max-width": "1018px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [
                  _vm._v(
                    "\n      正在" +
                      _vm._s(_vm.listName == "gsList" ? "公示" : "登记") +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { "padding-bottom": "1px" },
                  attrs: {
                    data: _vm.realInfoList,
                    "cell-style": _vm.judgeCellColor,
                    "header-cell-style": _vm.headerrow
                  }
                },
                _vm._l(_vm.gsMap, function(value, key) {
                  return _c("el-table-column", {
                    key: key,
                    attrs: { label: value, width: _vm.gsWMap[key] || "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              !scope.row[key]
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "rgba(0, 0, 0, 0.5)"
                                      }
                                    },
                                    [_vm._v("\n            待更新\n          ")]
                                  )
                                : typeof scope.row[key] === "string" &&
                                  scope.row[key].includes("\n")
                                ? _c(
                                    "div",
                                    { staticStyle: { "white-space": "pre" } },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(scope.row[key]) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _c("div", [_vm._v(_vm._s(scope.row[key]))])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hotingList.length > 0 && _vm.listName == "hotingList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1440px", margin: "50px auto" } },
            [
              _c(
                "h2",
                {
                  staticStyle: { "text-align": "center", "margin-top": "20px" }
                },
                [_vm._v("生命周期")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.filterHoting,
                    border: "",
                    "cell-style": _vm.judgeHotColor
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "district",
                      label: "区域",
                      width: "80",
                      filters: _vm.areaFilterList,
                      "filter-method": _vm.areaFilter
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "area_name", label: "板块", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘名称",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "number", label: "土拍编号", width: "150" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hang_date",
                      label: "土地挂牌",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deal_date",
                      label: "土地成交",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "plan", label: "规划公示" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "apart", label: "户型图" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "销售公示" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "expect", label: "预计开盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dynamic", label: "销售动态", width: "200" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.news.length > 0 && _vm.listName == "news"
        ? _c(
            "div",
            { staticStyle: { "max-width": "750px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("最新政府文章")]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { margin: "20px 0" } }, [
                _vm._v("\n      搜索文章："),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchText,
                      expression: "searchText"
                    }
                  ],
                  staticStyle: { width: "200px" },
                  attrs: {
                    type: "text",
                    placeholder: "输入文章标题或内容 回车查询"
                  },
                  domProps: { value: _vm.searchText },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.searchGovNews.apply(null, arguments)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchText = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "count" },
                [
                  _vm._v(
                    "\n      第" + _vm._s(_vm.pageNum + 1) + "页  \n      "
                  ),
                  _vm.pageNum > 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.beforeClick }
                        },
                        [_vm._v("上一页")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.nextClick }
                    },
                    [_vm._v("下一页")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.news, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "标题" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "90" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "site", label: "站点", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.currentNews = scope.row
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2179256391
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentNews
        ? _c("div", { staticClass: "image-background" }, [
            _c("div", { staticClass: "edit-area" }, [
              _c("div", { staticClass: "edit-left" }, [
                _vm._v(_vm._s(_vm.currentNews.content))
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentNews.summary,
                    expression: "currentNews.summary"
                  }
                ],
                staticClass: "edit-right",
                domProps: { value: _vm.currentNews.summary },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.currentNews, "summary", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "warning" },
                    on: {
                      click: function($event) {
                        _vm.currentNews = null
                      }
                    }
                  },
                  [_vm._v("取消")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "qunList"
        ? _c(
            "div",
            { staticStyle: { margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v(_vm._s(_vm.sendWay))]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { placeholder: "楼盘群" },
                  model: {
                    value: _vm.searchType,
                    callback: function($$v) {
                      _vm.searchType = $$v
                    },
                    expression: "searchType"
                  }
                },
                _vm._l(_vm.QunType, function(type) {
                  return _c("el-option", {
                    key: type,
                    attrs: { label: type, value: type }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.searchType === "销售聊天"
                ? _c(
                    "div",
                    { staticStyle: { margin: "20px 0" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "选择楼盘",
                            "default-first-option": "",
                            "remote-method": _vm.searchEstate,
                            remote: ""
                          },
                          on: { change: _vm.searchQun }
                        },
                        _vm._l(_vm.matchEstates, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.real_estate_name,
                              value: item.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _c("div", { staticStyle: { margin: "20px 0" } }, [
                    _vm._v("\n      搜索："),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchName,
                          expression: "searchName"
                        }
                      ],
                      staticStyle: { width: "200px" },
                      attrs: { type: "text", placeholder: "输入群名 回车查询" },
                      domProps: { value: _vm.searchName },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.searchQun.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchName = $event.target.value
                        }
                      }
                    })
                  ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    margin: "20px 0",
                    display: "flex",
                    "justify-content": "center"
                  }
                },
                [
                  _vm._v("\n      已选(默认全选,单击删除)：\n      "),
                  _vm._l(_vm.chooseList, function(n, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        on: {
                          click: function($event) {
                            return _vm.deletOne(index)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(n.name) + "\n      ")]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.sendWay == "创建小群"
                ? _c(
                    "div",
                    { staticStyle: { margin: "20px 0" } },
                    [
                      _vm._v("\n      小群名(不小于6字)："),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.content,
                            expression: "content"
                          }
                        ],
                        attrs: { cols: "50", rows: "5" },
                        domProps: { value: _vm.content },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.content = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.chooseList.length == 1 && _vm.content.length > 5
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addNewChat()
                                }
                              }
                            },
                            [_vm._v("确认创建")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sendWay != "创建小群"
                ? _c(
                    "div",
                    { staticStyle: { margin: "20px 0" } },
                    [
                      _vm._v("\n      发消息："),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.content,
                            expression: "content"
                          }
                        ],
                        attrs: { cols: "50", rows: "5" },
                        domProps: { value: _vm.content },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.content = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.sendQunMessage(1)
                            }
                          }
                        },
                        [_vm._v("发送文字")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sendWay === "假用户消息"
                ? _c(
                    "div",
                    [
                      _c("input", {
                        attrs: { type: "file" },
                        on: { change: _vm.chooseImage3 }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.sendQunMessage(2)
                            }
                          }
                        },
                        [_vm._v("发送图片")]
                      ),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.imageSrc))]),
                      _vm._v(" "),
                      _vm.imageSrc
                        ? _c("div", { staticClass: "imageBox" }, [
                            _c("img", {
                              attrs: { src: _vm.imageSrc, preview: "1" }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.delImage2()
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "file" },
                        on: { change: _vm.chooseVideo }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.sendQunMessage(43)
                            }
                          }
                        },
                        [_vm._v("发送视频")]
                      ),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.videoSrc))]),
                      _vm._v(" "),
                      _vm.videoSrc
                        ? _c("div", { staticClass: "imageBox" }, [
                            _c("img", {
                              attrs: { src: _vm.videoCover, preview: "1" }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.delVideo()
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { margin: "10px 0", width: "100px" },
                          attrs: { placeholder: "随机用户" },
                          model: {
                            value: _vm.suiji,
                            callback: function($$v) {
                              _vm.suiji = $$v
                            },
                            expression: "suiji"
                          }
                        },
                        _vm._l(
                          _vm.searchType == "话题群"
                            ? ["随机用户", "当前用户", "发帖用户"]
                            : ["随机用户", "当前用户"],
                          function(way) {
                            return _c("el-option", {
                              key: way,
                              attrs: { label: way, value: way }
                            })
                          }
                        ),
                        1
                      ),
                      _vm._v(
                        "\n      当前用户：" +
                          _vm._s(_vm.sjUser.user_name || "") +
                          "\n    "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.searchType === "销售聊天"
                ? _c("div", [
                    _c("div", [_vm._v("聊天记录：")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "talkbox" },
                      _vm._l(_vm.records, function(item, index) {
                        return _c("div", { key: index }, [
                          _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.userType) +
                                "：" +
                                _vm._s(item.content) +
                                "（" +
                                _vm._s(item.create_time) +
                                "）\n          "
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  style: {
                    "max-width": _vm.searchType == "楼盘群" ? "300px" : "200px",
                    margin: "50px auto"
                  },
                  attrs: { data: _vm.qunList, border: "", stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "群名/名字" }
                  }),
                  _vm._v(" "),
                  _vm.searchType == "楼盘群"
                    ? _c("el-table-column", {
                        attrs: { prop: "type", label: "类型", width: "80" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addQun(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("添加")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      100464192
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "priceReal"
        ? _c(
            "div",
            { staticStyle: { width: "1700px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("总价楼盘")]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { placeholder: "200万+" },
                  model: {
                    value: _vm.priceType,
                    callback: function($$v) {
                      _vm.priceType = $$v
                    },
                    expression: "priceType"
                  }
                },
                _vm._l(_vm.priceList, function(type) {
                  return _c("el-option", {
                    key: type,
                    attrs: { label: type, value: type }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { placeholder: "在售待首开" },
                  model: {
                    value: _vm.realStatus,
                    callback: function($$v) {
                      _vm.realStatus = $$v
                    },
                    expression: "realStatus"
                  }
                },
                _vm._l(["在售待首开", "售罄"], function(type) {
                  return _c("el-option", {
                    key: type,
                    attrs: { label: type, value: type }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getEstateZJ } },
                [_vm._v("查找")]
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v("共找到" + _vm._s(_vm.priceRealList.length) + "个楼盘")
              ]),
              _vm._v(" "),
              _vm.priceRealList.length > 0
                ? _c(
                    "el-table",
                    {
                      attrs: { data: _vm.priceRealList, border: "", stripe: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "real_estate_name", label: "楼盘名" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "priceStr", label: "价格" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "active_num", label: "热度(w)" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "district", label: "区域" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "area_name", label: "板块" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "subway", label: "交通" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "label2.lines_c", label: "地铁" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "allSmallSchool", label: "全部小学" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "smallSchool", label: "学区小学" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "allMiddleSchool", label: "全部中学" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "middleSchool", label: "学区中学" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "price", label: "二手房均价" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "label2.square", label: "户型面积" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "label2.room_count", label: "房间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "label2.type", label: "类型" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "label2.give_time", label: "交付" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "label2.daoguaPrice", label: "倒挂" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "rate_total", label: "最近中签率" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "location_level", label: "配套" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "invest", label: "投资" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "apartList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1000px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("4室户型")]
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v("共找到" + _vm._s(_vm.apartList.length) + "个户型")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "download-button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.downloadExcel("4室户型")
                    }
                  }
                },
                [_vm._v("导出Excel")]
              ),
              _vm._v(" "),
              _vm.apartList.length > 0
                ? _c(
                    "el-table",
                    { attrs: { data: _vm.apartList, border: "", stripe: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "real_estate_name", label: "楼盘名" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "district", label: "区域" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "area_name", label: "板块" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "house_style", label: "户型" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "allRoomSquare", label: "面积" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "hasPc", label: "是否评测" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "oldPriceList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1700px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("2-3万楼盘")]
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v("共找到" + _vm._s(_vm.oldPriceList.length) + "个楼盘")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "download-button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.downloadExcel("2-3万楼盘")
                    }
                  }
                },
                [_vm._v("导出Excel")]
              ),
              _vm._v(" "),
              _vm.oldPriceList.length > 0
                ? _c(
                    "el-table",
                    {
                      attrs: { data: _vm.oldPriceList, border: "", stripe: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "real_estate_name", label: "楼盘名" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "area_name", label: "板块" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "priceStr", label: "价格" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "expect.date", label: "预计开盘" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "houseList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("90方以下楼盘")]
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v("共找到" + _vm._s(_vm.houseList.length) + "个楼盘")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "download-button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.downloadExcel("90方楼盘")
                    }
                  }
                },
                [_vm._v("导出Excel")]
              ),
              _vm._v(" "),
              _vm.houseList.length > 0
                ? _c(
                    "el-table",
                    { attrs: { data: _vm.houseList, border: "", stripe: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "real_estate_name", label: "楼盘名" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "district", label: "区域" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "area_name", label: "板块" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "apart", label: "具体户型" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "guwenFuwu"
        ? _c(
            "div",
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "评论楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: ""
                  },
                  on: { change: _vm.changeCommentType },
                  model: {
                    value: _vm.commentEstateId,
                    callback: function($$v) {
                      _vm.commentEstateId = $$v
                    },
                    expression: "commentEstateId"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._v("\n      起始\n      "),
                  _c("el-date-picker", {
                    staticStyle: { width: "140px" },
                    attrs: {
                      type: "date",
                      placeholder: "起始日期",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.ax.start_time,
                      callback: function($$v) {
                        _vm.$set(_vm.ax, "start_time", $$v)
                      },
                      expression: "ax.start_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._v("\n      结束\n      "),
                  _c("el-date-picker", {
                    staticStyle: { width: "140px" },
                    attrs: {
                      type: "date",
                      placeholder: "结束日期",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.ax.end_time,
                      callback: function($$v) {
                        _vm.$set(_vm.ax, "end_time", $$v)
                      },
                      expression: "ax.end_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.getGuwenFuwu } }, [
                _vm._v("查看")
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.guwenList } },
                [
                  _c("el-table-column", {
                    attrs: { label: "顾问名", prop: "user_name" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "微聊人数", prop: "chat_person_num" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "微聊回复率", prop: "chat_rate" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "五分钟回复率", prop: "limit_time_rate" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "平均响应时长分", prop: "time" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "聊天条数", prop: "talk_num" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "申请交换微信数",
                      prop: "weixin_exchange_num"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "交换微信成功数",
                      prop: "weixin_exchange_agree_num"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "yujiExcel"
        ? _c(
            "div",
            { staticStyle: { "max-width": "300px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("预计开盘excel")]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { placeholder: "选择预计月份" },
                  model: {
                    value: _vm.yjMonth,
                    callback: function($$v) {
                      _vm.yjMonth = $$v
                    },
                    expression: "yjMonth"
                  }
                },
                _vm._l(_vm.monthList, function(type) {
                  return _c("el-option", {
                    key: type,
                    attrs: { label: type, value: type }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "normal",
                  attrs: { type: "primary" },
                  on: { click: _vm.yujiExcel }
                },
                [_vm._v("下载excel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "normal",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.yujiExcel("1")
                    }
                  }
                },
                [_vm._v("顾问4000活跃+")]
              ),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.yuJiUrl))]),
              _vm._v(" "),
              _vm.saleList.length > 0
                ? _c(
                    "el-table",
                    { attrs: { data: _vm.saleList, border: "", stripe: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "user_name", label: "顾问" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "thirty_num", label: "活跃度" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.needList.length
        ? _c(
            "div",
            { staticStyle: { "max-width": "780px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.needList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘",
                      width: "80"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "district", label: "区域", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "area_name", label: "板块", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "active_num", label: "热度", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "vrNum", label: "航拍", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "exportNum", label: "达人短评", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "artNum", label: "小鸡长文", width: "80" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "topicList"
        ? _c("div", { staticClass: "topicList" }, [
            _c(
              "div",
              { staticClass: "topic-check" },
              _vm._l(_vm.checkList, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticStyle: { margin: "20px 0" } },
                  [
                    _c("div", [
                      item.lnglat
                        ? _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.showTopicLoc(item)
                                }
                              }
                            },
                            [_vm._v("位置")]
                          )
                        : _vm._e(),
                      _vm._v("\n          " + _vm._s(item.words) + "\n        ")
                    ]),
                    _vm._v(" "),
                    item.images && item.images.length
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center"
                            }
                          },
                          _vm._l(item.images, function(img, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "cover" },
                              [
                                _c("el-image", {
                                  staticStyle: { height: "100px" },
                                  attrs: {
                                    src: img,
                                    fit: "cover",
                                    lazy: "",
                                    "preview-src-list": [
                                      img.replace("_mini.jpg", "")
                                    ]
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          staticStyle: { width: "180px" },
                          attrs: { type: "text", placeholder: "理由" },
                          model: {
                            value: item.note,
                            callback: function($$v) {
                              _vm.$set(item, "note", $$v)
                            },
                            expression: "item.note"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.pass(item)
                              }
                            }
                          },
                          [_vm._v("通过")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning" },
                            on: {
                              click: function($event) {
                                return _vm.refuse(item)
                              }
                            }
                          },
                          [_vm._v("拒绝")]
                        )
                      ],
                      1
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "topic-map" },
              [
                _c(
                  "el-amap",
                  {
                    ref: "checkTopic",
                    staticClass: "amap-box",
                    attrs: {
                      vid: "checkTopic",
                      zoom: _vm.zoom,
                      center: _vm.center,
                      "amap-manager": _vm.amapManager,
                      plugin: _vm.plugin
                    }
                  },
                  [
                    _vm.topicLnglat
                      ? _c("el-amap-marker", {
                          attrs: {
                            vid: "topic_check",
                            position: _vm.topicLnglat.split("-")[0].split("|"),
                            icon: "./../../static/images/marker.png"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "salePut"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("销售上传")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.salePut, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.图片", label: "图片", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.话题", label: "话题", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.问题", label: "问题", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "temp.预计开盘",
                      label: "预计开盘",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "temp.公示登记",
                      label: "公示登记",
                      width: "100"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "inviteList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("运营组数据")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.inviteList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.inviteListUsers, function(user) {
                    return _c("el-table-column", {
                      key: user,
                      attrs: { prop: "temp." + user, label: user }
                    })
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "szInviteList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("运营组数据")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.szInviteList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.王向宏", label: "王向宏" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.波波", label: "波波" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.丁心雨", label: "丁心雨" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "temp.木兵兵", label: "木兵兵" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "sunHouse"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v(_vm._s(_vm.value))]
              ),
              _vm._v(" "),
              _c("h3", [_vm._v("总计" + _vm._s(_vm.uploadNum) + "个")]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.sunHouse, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "上传者" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "serial_number", label: "户型编号" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "estateImgCheck"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.estateImgCheck, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "图片数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.examine(scope.row, "图库")
                                    }
                                  }
                                },
                                [_vm._v("审核")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1858980699
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "hangImgCheck"
        ? _c(
            "div",
            { staticStyle: { "max-width": "800px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.hangImgCheck, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘",
                      width: "150px;"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "number", label: "编号", width: "130px;" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "square", label: "面积" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "layout", label: "户型" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "floor", label: "楼层", width: "120px;" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "trim", label: "装修" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "图片", width: "50px;" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.examine(scope.row, "房源图库")
                                    }
                                  }
                                },
                                [_vm._v("审核")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4043322196
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "HzTitle"
        ? _c(
            "div",
            { staticStyle: { "max-width": "500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("杭州公示")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.HzTitle, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "公示日期", width: "160" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "标题" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "ZJReal"
        ? _c(
            "div",
            { staticStyle: { "max-width": "900px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("中签率楼盘")]
              ),
              _vm._v(" "),
              _vm.ZJReal.length > 0
                ? _c(
                    "el-table",
                    { attrs: { data: _vm.ZJReal, border: "", stripe: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "real_estate_name", label: "楼盘" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "advance", label: "时间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "building", label: "楼栋" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "rate_total", label: "最近中签率" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "sortList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "800px", margin: "50px auto" } },
            _vm._l(_vm.sortList, function(s, index) {
              return _c("div", { key: index }, [
                _c(
                  "h2",
                  { staticStyle: { "text-align": "center", margin: "20px 0" } },
                  [_vm._v(_vm._s(s.type))]
                ),
                _vm._v(" "),
                s.type !== "近期话题" && s.type !== "近期PK"
                  ? _c(
                      "div",
                      [
                        s.list.length > 0
                          ? _c(
                              "el-table",
                              {
                                attrs: { data: s.list, border: "", stripe: "" }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "real_estate_name",
                                    label: "楼盘"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "sortTip", label: s.type }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                s.type === "近期PK"
                  ? _c(
                      "div",
                      [
                        s.list.length > 0
                          ? _c(
                              "el-table",
                              {
                                attrs: { data: s.list, border: "", stripe: "" }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "fina", label: "楼盘" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "create_time", label: "时间" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { prop: "views_num", label: "围观" }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                s.type === "近期话题"
                  ? _c(
                      "div",
                      _vm._l(s.list, function(l, index2) {
                        return _c("div", { key: index2 }, [
                          _c("div", [
                            _vm._v(
                              "(围观" +
                                _vm._s(l.views_num) +
                                ")(" +
                                _vm._s(l.create_time) +
                                ")" +
                                _vm._s(l.words)
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "fDiv" },
                            _vm._l(l.images, function(img, index3) {
                              return _c("div", { key: index3 }, [
                                _c("img", { attrs: { src: img, preview: "1" } })
                              ])
                            }),
                            0
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.adCloseList.length > 0 && _vm.listName == "adCloseList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("展位即将到期")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.adCloseList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "end_time", label: "到期时间" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.logList.length > 0 && _vm.listName == "logList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "800px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("错误日志")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.logList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "from", label: "来源", width: "130" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "message", label: "错误信息", width: "130" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "detail", label: "错误详情" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "create_time", label: "时间", width: "130" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.xhLogList.length > 0 && _vm.listName == "xhLogList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "800px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("错误日志")]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.error_platform,
                      expression: "error_platform"
                    }
                  ],
                  attrs: { name: "", id: "" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.error_platform = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.getXHLogs()
                      }
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "android" } }, [
                    _vm._v("android")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "ios" } }, [_vm._v("ios")])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getXHLogs(_vm.xhLogMaxId)
                    }
                  }
                },
                [_vm._v("下一页")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.xhLogList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "error", label: "错误信息" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                { staticStyle: { "white-space": "pre-line" } },
                                [_vm._v(_vm._s(row.error))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3974508898
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "create_time", label: "时间", width: "130" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.spiderData.length > 0 && _vm.listName == "spiderData"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1080px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("二手房爬虫")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.spiderData, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "haoNewHang", label: "hzf新增房源" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "haoAllHang", label: "hzf有效房源" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "beikeHang", label: "bk更新房源" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "wiwjHang", label: "5i5j更新房源" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "haoDeal", label: "hzf成交记录" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "wiwjDeal", label: "5i5j成交记录" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "beikeDaikan", label: "bk带看" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "wiwjDaikan", label: "5i5j带看" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mpCode
        ? _c("div", { staticClass: "image-background" }, [
            _c("div", { staticClass: "image-preview" }, [
              _c(
                "span",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      _vm.mpCode = null
                    }
                  }
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: _vm.mpCode,
                  width: "400px",
                  height: "400px",
                  preview: "1"
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mpCode2
        ? _c("div", { staticClass: "image-background" }, [
            _c(
              "div",
              { staticClass: "image-preview2" },
              [
                _c(
                  "span",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        _vm.mpCode2 = null
                      }
                    }
                  },
                  [_vm._v("关闭")]
                ),
                _vm._v(" "),
                _c("el-image", {
                  style: { width: "281px", height: "600px" },
                  attrs: { src: _vm.mpCode2, "preview-src-list": [_vm.mpCode2] }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "messList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("群聊统计")]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { placeholder: "今天" },
                  model: {
                    value: _vm.dateType,
                    callback: function($$v) {
                      _vm.dateType = $$v
                    },
                    expression: "dateType"
                  }
                },
                _vm._l(_vm.dateList, function(s) {
                  return _c("el-option", {
                    key: s,
                    attrs: { label: s, value: s }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getWkMessage } },
                [_vm._v("查找")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.messList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "群id" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "nickName", label: "群名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "聊天信息" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "friedList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1000px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("炒群记录")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.friedList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "时间", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "名字" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "chat_name", label: "群名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "chao", label: "炒群" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "alladd", label: "新增" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "salesMsgNum"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("销售群聊消息数排名")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.salesMsgNum, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "index", label: "排名", width: "50" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "消息数", width: "80" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "findPageAd"
        ? _c("div", [
            _c(
              "h2",
              { staticStyle: { "text-align": "center", margin: "20px 0" } },
              [_vm._v("展位预定")]
            ),
            _vm._v(" "),
            _c(
              "h3",
              { staticStyle: { "text-align": "center", margin: "20px 0" } },
              [_vm._v(_vm._s(_vm.saleAdType))]
            ),
            _vm._v(" "),
            _vm.salePayList.length
              ? _c(
                  "div",
                  { staticClass: "salePays" },
                  _vm._l(_vm.salePayList, function(onepay, index) {
                    return _c("div", { key: index, staticClass: "salePay" }, [
                      _c("div", [_vm._v(_vm._s(onepay.user_name))]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._v("\n          起始\n          "),
                          _c("el-date-picker", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              type: "date",
                              placeholder: "起始日期",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: onepay.start_time,
                              callback: function($$v) {
                                _vm.$set(onepay, "start_time", $$v)
                              },
                              expression: "onepay.start_time"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm._v("\n          结束\n          "),
                          _c("el-date-picker", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              type: "date",
                              placeholder: "结束日期",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: onepay.end_time,
                              callback: function($$v) {
                                _vm.$set(onepay, "end_time", $$v)
                              },
                              expression: "onepay.end_time"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { margin: "5px 0" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(onepay.money) +
                            "元：" +
                            _vm._s(onepay.way) +
                            "\n          "
                        ),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.modSalePay(index)
                              }
                            }
                          },
                          [_vm._v("改日期")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: onepay.outMoney,
                              expression: "onepay.outMoney"
                            }
                          ],
                          staticStyle: { width: "100px" },
                          attrs: {
                            type: "number",
                            placeholder: "退订金额(元)"
                          },
                          domProps: { value: onepay.outMoney },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(onepay, "outMoney", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.cancelSalePay(index)
                              }
                            }
                          },
                          [_vm._v("退订")]
                        )
                      ])
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm._v("\n      广告位置\n      "),
                _c(
                  "el-select",
                  {
                    on: { change: _vm.onSaleAdTypeChange },
                    model: {
                      value: _vm.saleAdType,
                      callback: function($$v) {
                        _vm.saleAdType = $$v
                      },
                      expression: "saleAdType"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: {
                        label: "找新房优秀顾问",
                        value: "找新房优秀顾问"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: {
                        label: "找新房猜你喜欢",
                        value: "找新房猜你喜欢"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-option", {
                      attrs: { label: "首页新房榜单", value: "首页新房榜单" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "normal" },
              [
                _vm._v("\n      搜索销售\n      "),
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      placeholder: "搜索销售姓名",
                      "default-first-option": "",
                      "remote-method": _vm.chooseSaleName,
                      remote: ""
                    },
                    on: { change: _vm.searchSaleName },
                    model: {
                      value: _vm.search_word,
                      callback: function($$v) {
                        _vm.search_word = $$v
                      },
                      expression: "search_word"
                    }
                  },
                  _vm._l(_vm.allSaleName, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: {
                        label: item.user_name + "(" + item.user_type + ")",
                        value: item.user_name
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "salesmanList" },
              _vm._l(_vm.salesmanList, function(sale, index) {
                return _c("div", { key: index, staticClass: "sale" }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" }
                    },
                    [
                      _c("img", { attrs: { src: sale.head_url } }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { margin: "0 10px" } }, [
                        _vm._v(_vm._s(sale.user_name))
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(sale.estate_name || "无楼盘"))]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.setToShow(sale)
                            }
                          }
                        },
                        [_vm._v("上展位")]
                      )
                    ],
                    1
                  )
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "预定展位下单",
            visible: _vm.payVisible,
            width: "25%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.payVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "置业顾问", "label-width": _vm.labelWidth } },
                [_c("span", [_vm._v(_vm._s(_vm.payUser.user_name))])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "起始日期", "label-width": _vm.labelWidth } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "140px" },
                    attrs: {
                      type: "date",
                      placeholder: "起始日期",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.payUser.start_time,
                      callback: function($$v) {
                        _vm.$set(_vm.payUser, "start_time", $$v)
                      },
                      expression: "payUser.start_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "结束日期", "label-width": _vm.labelWidth } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "140px" },
                    attrs: {
                      type: "date",
                      placeholder: "起始日期",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.payUser.end_time,
                      callback: function($$v) {
                        _vm.$set(_vm.payUser, "end_time", $$v)
                      },
                      expression: "payUser.end_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "付费金额", "label-width": _vm.labelWidth } },
                [
                  _c("el-input", {
                    attrs: { type: "number" },
                    model: {
                      value: _vm.payUser.money,
                      callback: function($$v) {
                        _vm.$set(_vm.payUser, "money", $$v)
                      },
                      expression: "payUser.money"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "付费方式", "label-width": _vm.labelWidth } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        "default-first-option": "",
                        placeholder: "选择付费方式",
                        size: "mini"
                      },
                      model: {
                        value: _vm.payUser.way,
                        callback: function($$v) {
                          _vm.$set(_vm.payUser, "way", $$v)
                        },
                        expression: "payUser.way"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "微信", value: "微信" }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "支付宝", value: "支付宝" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.payVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setSalePay } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.listName === "commentEstate"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _c("div", { staticClass: "normal" }, [
                _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _c("el-input", {
                      staticStyle: { "font-size": "18px" },
                      attrs: {
                        type: "textarea",
                        placeholder: "评论内容",
                        cols: "70",
                        rows: "10"
                      },
                      model: {
                        value: _vm.commentWord,
                        callback: function($$v) {
                          _vm.commentWord = $$v
                        },
                        expression: "commentWord"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "normal" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "评论账号",
                        "default-first-option": ""
                      },
                      model: {
                        value: _vm.commentUserId,
                        callback: function($$v) {
                          _vm.commentUserId = $$v
                        },
                        expression: "commentUserId"
                      }
                    },
                    _vm._l(_vm.commentUsers, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.user_name, value: item.id }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.commentType === "板块评测"
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "评论板块",
                            "default-first-option": "",
                            "remote-method": _vm.searchArea,
                            remote: ""
                          },
                          model: {
                            value: _vm.commentAreaId,
                            callback: function($$v) {
                              _vm.commentAreaId = $$v
                            },
                            expression: "commentAreaId"
                          }
                        },
                        _vm._l(_vm.matchAreas, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.area_name, value: item.id }
                          })
                        }),
                        1
                      )
                    : _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "评论楼盘",
                            "default-first-option": "",
                            "remote-method": _vm.searchEstate,
                            remote: ""
                          },
                          on: { change: _vm.changeCommentType },
                          model: {
                            value: _vm.commentEstateId,
                            callback: function($$v) {
                              _vm.commentEstateId = $$v
                            },
                            expression: "commentEstateId"
                          }
                        },
                        _vm._l(_vm.matchEstates, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.real_estate_name,
                              value: item.id
                            }
                          })
                        }),
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "评论类型",
                        "default-first-option": ""
                      },
                      on: { change: _vm.changeCommentType },
                      model: {
                        value: _vm.commentType,
                        callback: function($$v) {
                          _vm.commentType = $$v
                        },
                        expression: "commentType"
                      }
                    },
                    _vm._l(_vm.commentTypes, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.commentType == "楼盘评测" && _vm.commentWordList.pingjia
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "楼盘评价",
                            "default-first-option": ""
                          },
                          on: { change: _vm.changeCommentWordType1 },
                          model: {
                            value: _vm.commentdd1,
                            callback: function($$v) {
                              _vm.commentdd1 = $$v
                            },
                            expression: "commentdd1"
                          }
                        },
                        _vm._l(_vm.commentWordList.pingjia, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.louDong, value: item.louDong }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.commentType == "楼盘评测" && _vm.commentWordList.pingjia
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "状态",
                            "default-first-option": ""
                          },
                          on: { change: _vm.changeCommentWordType3 },
                          model: {
                            value: _vm.commentdd3,
                            callback: function($$v) {
                              _vm.commentdd3 = $$v
                            },
                            expression: "commentdd3"
                          }
                        },
                        _vm._l(_vm.commentdd13, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.key, value: item.key }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.commentType == "3D选房评测" &&
                  _vm.commentWordList.xuanfanghao
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "已开盘户号评测",
                            "default-first-option": ""
                          },
                          on: { change: _vm.changeCommentWordType2 },
                          model: {
                            value: _vm.commentdd2,
                            callback: function($$v) {
                              _vm.commentdd2 = $$v
                            },
                            expression: "commentdd2"
                          }
                        },
                        _vm._l(_vm.commentWordList.xuanfanghao, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.key, value: item.key }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.commentType === "户型评测" ||
                  _vm.commentType === "样板房评测"
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "评论户型",
                            "default-first-option": ""
                          },
                          model: {
                            value: _vm.commentApart,
                            callback: function($$v) {
                              _vm.commentApart = $$v
                            },
                            expression: "commentApart"
                          }
                        },
                        _vm._l(_vm.commentAparts, function(item) {
                          return _c("el-option", {
                            key: item.imgName2,
                            attrs: {
                              label: item.imgName1 + " " + item.imgName2,
                              value: item.imgName2
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.commentType == "样板房评测" &&
                  _vm.commentWordList.length > 0
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "样板房评测",
                            "default-first-option": ""
                          },
                          on: { change: _vm.changeCommentWordType4 },
                          model: {
                            value: _vm.commentdd4,
                            callback: function($$v) {
                              _vm.commentdd4 = $$v
                            },
                            expression: "commentdd4"
                          }
                        },
                        _vm._l(_vm.commentWordList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.commentFlag },
                  on: { click: _vm.addEstateComment }
                },
                [_vm._v("评论")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showzhineng()
                    }
                  }
                },
                [_vm._v("显示智能问答评论")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "fakeSaleAd"
        ? _c("div", [
            _c(
              "h2",
              { staticStyle: { "text-align": "center", margin: "20px 0" } },
              [_vm._v("顾问小号展位")]
            ),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "text", placeholder: "回车搜索顾问" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchUser.apply(null, arguments)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "normal" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      placeholder: "搜索楼盘",
                      "default-first-option": "",
                      "remote-method": _vm.searchEstate,
                      remote: ""
                    },
                    model: {
                      value: _vm.fakeSaleAdEstate,
                      callback: function($$v) {
                        _vm.fakeSaleAdEstate = $$v
                      },
                      expression: "fakeSaleAdEstate"
                    }
                  },
                  _vm._l(_vm.matchEstates, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.real_estate_name, value: item.id }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                _vm._l(_vm.nameSearchUsers, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "margin-top": "20px"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "50px",
                          height: "50px",
                          "border-radius": "50%"
                        },
                        attrs: { src: item.head_url, alt: "没有头像" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(_vm._s(item.user_name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          on: {
                            click: function($event) {
                              return _vm.setFakeSaleAd(item)
                            }
                          }
                        },
                        [_vm._v("\n            上广告\n          ")]
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { "margin-bottom": "50px", "margin-top": "10px" }
              },
              _vm._l(_vm.fakeSaleAd, function(item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v(_vm._s(item.real_estate_name))]),
                    _vm._v(" "),
                    _c("img", {
                      staticStyle: {
                        width: "50px",
                        height: "50px",
                        "border-radius": "50%"
                      },
                      attrs: { src: item.user.head_url, alt: "" }
                    }),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(item.user.user_name))]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        on: {
                          click: function($event) {
                            return _vm.downFakeSaleAd(item)
                          }
                        }
                      },
                      [_vm._v("\n          取消\n        ")]
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "waitMatchList"
        ? _c(
            "div",
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.matchListSearchText,
                    expression: "matchListSearchText"
                  }
                ],
                attrs: { type: "text", placeholder: "搜索" },
                domProps: { value: _vm.matchListSearchText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.matchListSearchText = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", [_vm._v("剩余" + _vm._s(_vm.waitMatchList.length))]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "normal",
                  attrs: { type: "primary" },
                  on: { click: _vm.setMatchName }
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _vm._l(_vm.showWaitMatchList, function(item) {
                return _c("div", { key: item.name }, [
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.match,
                        expression: "item.match"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: item.match },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "match", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.showAddress(item.name)
                        }
                      }
                    },
                    [_vm._v("看地址")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.startMultiMatch(item.name)
                        }
                      }
                    },
                    [_vm._v("1对多")]
                  ),
                  _vm._v(" "),
                  _vm.currentMulti.name === item.name
                    ? _c(
                        "div",
                        [
                          _vm._l(_vm.currentMulti.list, function(
                            multiOne,
                            index
                          ) {
                            return _c("div", { key: index }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: multiOne.name,
                                    expression: "multiOne.name"
                                  }
                                ],
                                attrs: { type: "text", placeholder: "名称" },
                                domProps: { value: multiOne.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      multiOne,
                                      "name",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: multiOne.id,
                                    expression: "multiOne.id"
                                  }
                                ],
                                attrs: { type: "text", placeholder: "id" },
                                domProps: { value: multiOne.id },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      multiOne,
                                      "id",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.addMultiMatchOne()
                                }
                              }
                            },
                            [_vm._v("添加")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.saveMultiMatch()
                                }
                              }
                            },
                            [_vm._v("保存")]
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentAddress.name === item.name
                    ? _c(
                        "div",
                        _vm._l(_vm.currentAddress.list, function(addr) {
                          return _c("div", { key: addr }, [
                            _vm._v(_vm._s(addr))
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "hadMatchList"
        ? _c(
            "div",
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.matchListSearchText,
                    expression: "matchListSearchText"
                  }
                ],
                attrs: { type: "text", placeholder: "搜索" },
                domProps: { value: _vm.matchListSearchText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.matchListSearchText = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.showHadMatchList, function(item) {
                return _c("div", { key: item.estate_name }, [
                  _c("span", [_vm._v(_vm._s(item.estate_name))]),
                  _vm._v(" : "),
                  _c("span", [_vm._v(_vm._s(item.match_name))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.cancelMatch(item)
                        }
                      }
                    },
                    [_vm._v("取消匹配")]
                  )
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "redEvbag"
        ? _c("div", [
            _vm.listName === "redEvbag" && _vm.redList === "table"
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _c("el-button", { on: { click: _vm.setredEvbag } }, [
                        _vm._v("新增")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        { attrs: { data: _vm.redBagList } },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "id", label: "id" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "money", label: "金额(元)" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "extra", label: "剩余金额(元)" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "start_time", label: "开始时间" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "deal_time", label: "结束时间" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "estate_name", label: "楼盘名" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "", label: "操作" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.changeRedBag(row)
                                            }
                                          }
                                        },
                                        [_vm._v(" 编辑红包内容 ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              977975505
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.listName === "redEvbag" && _vm.redList === "inputRedAdd"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "选择楼盘",
                          "default-first-option": "",
                          "remote-method": _vm.searchEstate,
                          remote: ""
                        },
                        on: { change: _vm.changeCommentType },
                        model: {
                          value: _vm.redObj.estate_id,
                          callback: function($$v) {
                            _vm.$set(_vm.redObj, "estate_id", $$v)
                          },
                          expression: "redObj.estate_id"
                        }
                      },
                      _vm._l(_vm.matchEstates, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: item.real_estate_name,
                            value: item.id
                          }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        总金额(元):"),
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: { type: "number" },
                          model: {
                            value: _vm.redObj.money,
                            callback: function($$v) {
                              _vm.$set(_vm.redObj, "money", $$v)
                            },
                            expression: "redObj.money"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        开始时间：\n        "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "选择日期时间",
                            "default-time": "00:00:00"
                          },
                          model: {
                            value: _vm.redObj.start_time,
                            callback: function($$v) {
                              _vm.$set(_vm.redObj, "start_time", $$v)
                            },
                            expression: "redObj.start_time"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        结束时间：\n        "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "选择日期时间",
                            "default-time": "23:59:59"
                          },
                          model: {
                            value: _vm.redObj.deal_time,
                            callback: function($$v) {
                              _vm.$set(_vm.redObj, "deal_time", $$v)
                            },
                            expression: "redObj.deal_time"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.saveRed("新增")
                                  }
                                }
                              },
                              [_vm._v("保存")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.listName === "redEvbag" && _vm.redList === "inputRedChange"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "选择楼盘",
                          "default-first-option": "",
                          "remote-method": _vm.searchEstate,
                          remote: ""
                        },
                        on: { change: _vm.changeCommentType },
                        model: {
                          value: _vm.redObj.estate_id,
                          callback: function($$v) {
                            _vm.$set(_vm.redObj, "estate_id", $$v)
                          },
                          expression: "redObj.estate_id"
                        }
                      },
                      _vm._l(_vm.matchEstates, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: item.real_estate_name,
                            value: item.id
                          }
                        })
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        总金额(元):"),
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: { type: "number" },
                          model: {
                            value: _vm.redObj.money,
                            callback: function($$v) {
                              _vm.$set(_vm.redObj, "money", $$v)
                            },
                            expression: "redObj.money"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        开始时间：\n        "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "选择日期时间",
                            "default-time": "00:00:00"
                          },
                          model: {
                            value: _vm.redObj.start_time,
                            callback: function($$v) {
                              _vm.$set(_vm.redObj, "start_time", $$v)
                            },
                            expression: "redObj.start_time"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "normal" },
                      [
                        _vm._v("\n        结束时间：\n        "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "选择日期时间",
                            "default-time": "23:59:59"
                          },
                          model: {
                            value: _vm.redObj.deal_time,
                            callback: function($$v) {
                              _vm.$set(_vm.redObj, "deal_time", $$v)
                            },
                            expression: "redObj.deal_time"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.saveRed("修改")
                                  }
                                }
                              },
                              [_vm._v("保存")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "setEstateSort" && _vm.estateSortObj.id
        ? _c(
            "div",
            [
              _c("h2", [_vm._v(_vm._s(_vm.estateSortObj.name))]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "选择楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: ""
                  },
                  on: { change: _vm.addEstateToSort },
                  model: {
                    value: _vm.estateSortId,
                    callback: function($$v) {
                      _vm.estateSortId = $$v
                    },
                    expression: "estateSortId"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.estateSortObj.list, function(item, index) {
                return _c("div", { key: item.id, staticClass: "normal" }, [
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.setToTop(index)
                        }
                      }
                    },
                    [_vm._v("置顶")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.moveOut(index)
                        }
                      }
                    },
                    [_vm._v("移除")]
                  )
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "normal" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveEstateSort }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "checkTalks"
        ? _c(
            "div",
            [
              _c(
                "h2",
                {
                  staticStyle: { "text-align": "center", margin: "20px 0" },
                  attrs: { id: "infotop" }
                },
                [_vm._v("\n      楼盘群消息记录\n    ")]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  on: { change: _vm.getOneDayTalk },
                  model: {
                    value: _vm.loupanCheck,
                    callback: function($$v) {
                      _vm.loupanCheck = $$v
                    },
                    expression: "loupanCheck"
                  }
                },
                [
                  _c("el-option", { attrs: { value: "楼盘" } }, [
                    _vm._v("楼盘")
                  ]),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: "其他" } }, [
                    _vm._v("其他")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "选择日期"
                },
                on: {
                  change: function($event) {
                    return _vm.getOneDayTalk()
                  }
                },
                model: {
                  value: _vm.checkTalksDate,
                  callback: function($$v) {
                    _vm.checkTalksDate = $$v
                  },
                  expression: "checkTalksDate"
                }
              }),
              _vm._v(" "),
              _vm.checkTalksNum
                ? _c("h3", [_vm._v(_vm._s(_vm.checkTalksNum))])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.checkTalks, function(item, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loupanCheck == "楼盘",
                        expression: "loupanCheck == '楼盘'"
                      }
                    ],
                    key: index,
                    staticStyle: { "max-width": "1100px", margin: "50px auto" }
                  },
                  [
                    _c("div", [_vm._v(_vm._s(item.name))]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      { attrs: { data: item.msgList, border: "", stripe: "" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "user_id",
                            label: "用户id",
                            width: "100"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "内容" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    row.type == 2
                                      ? _c("el-image", {
                                          staticStyle: {
                                            width: "100px",
                                            height: "100px"
                                          },
                                          attrs: {
                                            src: row.content,
                                            "preview-src-list": [row.content],
                                            fit: "contain",
                                            lazy: ""
                                          }
                                        })
                                      : _c("div", [_vm._v(_vm._s(row.content))])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "时间",
                            width: "150"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "state", label: "状态", width: "80" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(row.state || "暂无状态"))
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "510" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _vm.talkSelectGroup === "数据"
                                      ? _c(
                                          "el-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.uploadQuestion(
                                                  row.content,
                                                  row.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("录入问题")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.toUserChatHistory(
                                              row.user_id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              查看用户聊天记录\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.talkSelectGroup === "运营" &&
                                    row.type == 1
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: row.label1,
                                                    expression: "row.label1"
                                                  }
                                                ],
                                                on: {
                                                  change: function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.$set(
                                                      row,
                                                      "label1",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  }
                                                }
                                              },
                                              _vm._l(
                                                _vm.topicLabelMap,
                                                function(va, label) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: label,
                                                      domProps: { value: label }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(label) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: row.label2,
                                                    expression: "row.label2"
                                                  }
                                                ],
                                                staticStyle: {
                                                  "margin-right": "10px"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.$set(
                                                      row,
                                                      "label2",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  }
                                                }
                                              },
                                              _vm._l(
                                                _vm.topicLabelMap[row.label1],
                                                function(label) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: label,
                                                      domProps: { value: label }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(label) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.topicWordSelect(
                                                      row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("入库")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.topOneTalk(row)
                                                  }
                                                }
                                              },
                                              [_vm._v("置顶展示")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.loupanCheck == "其他"
                ? _c(
                    "div",
                    _vm._l(_vm.checkTalks, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            "max-width": "1000px",
                            margin: "50px auto"
                          }
                        },
                        [
                          _c(
                            "el-table",
                            { attrs: { data: item, border: "", stripe: "" } },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "user_id",
                                  label: "用户id",
                                  width: "100"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { prop: "content", label: "内容" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_time",
                                  label: "时间",
                                  width: "150"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "status",
                                  label: "状态",
                                  width: "150"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "state",
                                  label: "录入",
                                  width: "150"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(row.state || "暂无状态")
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "260" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.uploadQuestion(
                                                    row.content,
                                                    row.id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("录入问题")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.toUserChatHistory(
                                                    row.user_id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                查看用户聊天记录\n              "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticStyle: {
                    position: "fixed",
                    bottom: "20px",
                    right: "30px"
                  },
                  attrs: { href: "#infotop" }
                },
                [_vm._v("回到顶部")]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "checkEveryTalk" || _vm.listName === "searchToUnlock"
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listName === "checkEveryTalk",
                      expression: "listName === 'checkEveryTalk'"
                    }
                  ]
                },
                [
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "center", margin: "20px 0" },
                      attrs: { id: "talk_title" }
                    },
                    [_vm._v("\n        群聊地毯式检查\n      ")]
                  ),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "按日期检查"
                    },
                    on: {
                      change: function($event) {
                        return _vm.checkEveryTalk()
                      }
                    },
                    model: {
                      value: _vm.everyTalkDate,
                      callback: function($$v) {
                        _vm.everyTalkDate = $$v
                      },
                      expression: "everyTalkDate"
                    }
                  }),
                  _vm._v("\n      或\n      "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.checkEveryTalk("recent")
                        }
                      }
                    },
                    [_vm._v("按最近检查")]
                  ),
                  _vm._v(" "),
                  _vm.showEveryOver
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.setAllCheck }
                        },
                        [_vm._v("本次已全部审核")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.partTalkList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      "max-width": "800px",
                      margin: "50px auto 0 auto"
                    }
                  },
                  [
                    _c("div", [_vm._v(_vm._s(item.chat.name))]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      { attrs: { data: item.msgList, border: "", stripe: "" } },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "typeStr", label: "类别", width: "60" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "内容" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { display: "inline-block" }
                                      },
                                      [
                                        scope.row.type === 1 ||
                                        scope.row.type === 10
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(scope.row.content) +
                                                  "\n              "
                                              )
                                            ])
                                          : scope.row.type === 2
                                          ? _c(
                                              "div",
                                              [
                                                _c("el-image", {
                                                  staticStyle: {
                                                    width: "100px",
                                                    height: "100px"
                                                  },
                                                  attrs: {
                                                    src: scope.row.content,
                                                    "preview-src-list": [
                                                      scope.row.content
                                                    ],
                                                    fit: "contain",
                                                    lazy: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : scope.row.type === 43
                                          ? _c(
                                              "div",
                                              [
                                                _c("el-button", [
                                                  _vm._v("播放视频")
                                                ])
                                              ],
                                              1
                                            )
                                          : scope.row.type === 9 ||
                                            scope.row.type === 48
                                          ? _c(
                                              "div",
                                              [
                                                scope.row.content.images
                                                  ? _c("el-image", {
                                                      staticStyle: {
                                                        width: "100px",
                                                        height: "100px"
                                                      },
                                                      attrs: {
                                                        src:
                                                          scope.row.content
                                                            .images,
                                                        "preview-src-list": [
                                                          scope.row.content
                                                            .images
                                                        ],
                                                        fit: "contain",
                                                        lazy: ""
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.content.words
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : scope.row.type === 21 ||
                                            scope.row.type === 22
                                          ? _c("div", [
                                              scope.row.type === 22
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "border-bottom":
                                                          "1px solid #cccccc",
                                                        "margin-bottom": "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  自己：" +
                                                          _vm._s(
                                                            scope.row.content
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c("span", [
                                                    _vm._v("对方：")
                                                  ]),
                                                  _vm._v(" "),
                                                  scope.row.target.type == 1
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              scope.row.target
                                                                .content
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ])
                                                    : scope.row.target.type == 2
                                                    ? _c("el-image", {
                                                        staticStyle: {
                                                          width: "100px",
                                                          height: "100px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            scope.row.target
                                                              .content,
                                                          "preview-src-list": [
                                                            scope.row.target
                                                              .content
                                                          ],
                                                          fit: "contain",
                                                          lazy: ""
                                                        }
                                                      })
                                                    : scope.row.target.type ==
                                                      43
                                                    ? _c("el-button", [
                                                        _vm._v("播放视频")
                                                      ])
                                                    : _c("span", [
                                                        _vm._v("其它消息")
                                                      ])
                                                ],
                                                1
                                              )
                                            ])
                                          : _c("div", [_vm._v("其它消息")])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "发布者", width: "80" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { display: "inline-block" }
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px"
                                          },
                                          attrs: {
                                            src: scope.row.user.head_url,
                                            "preview-src-list": [
                                              scope.row.user.head_url
                                            ],
                                            fit: "fit",
                                            lazy: ""
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row.user.user_name)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        scope.row.user.user_type
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "info" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.user.user_type
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.user.user_status
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "danger" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.user.user_status
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "status", label: "状态", width: "60" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "时间",
                            width: "130"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            return _vm.lahei(
                                              scope.row,
                                              scope.$index
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("拉黑")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "hide-on-single-page": "",
                  layout: "prev, pager, next",
                  "page-size": 1,
                  "prev-text": "上一页",
                  "next-text": "下一页",
                  total: _vm.everyTalkList.length
                },
                on: { "current-change": _vm.changeTalkPage },
                model: {
                  value: _vm.talkPage,
                  callback: function($$v) {
                    _vm.talkPage = $$v
                  },
                  expression: "talkPage"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "white" })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "questionStatusList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "800px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("智能问答匹配情况")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.questionStatusList,
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "总数" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "1", label: "未匹配" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "2", label: "已匹配" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "3", label: "已审核" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "5", label: "待定" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "6", label: "疑难" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "4", label: "删除" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "7", label: "二轮核对" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "8", label: "无需回答" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "adTotal"
        ? _c(
            "div",
            [
              _c("h2", [_vm._v("广告位统计")]),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.ad_List, border: "", height: "60vh" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "广告位置", prop: "type", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.value2show[scope.row.type] ||
                                      scope.row.type
                                  ) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1004032033
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "正在上架",
                        prop: "online",
                        align: "center"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "楼盘名",
                          prop: "online",
                          align: "center",
                          className: "my_cell"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return _vm._l(row.online, function(
                                  item,
                                  index
                                ) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.estate_name) +
                                        "\n            "
                                    )
                                  ])
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          3119005861
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "上架时间",
                          prop: "online",
                          align: "center",
                          className: "my_cell"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return _vm._l(row.online, function(
                                  item,
                                  index
                                ) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.start_time) +
                                        "\n            "
                                    )
                                  ])
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          4193266789
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "下架时间",
                          prop: "online",
                          align: "center",
                          className: "my_cell"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return _vm._l(row.online, function(
                                  item,
                                  index
                                ) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.end_time) +
                                        "\n            "
                                    )
                                  ])
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          237649226
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "暂未上架",
                        prop: "wait",
                        align: "center"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "楼盘名",
                          prop: "wait",
                          align: "center",
                          className: "my_cell"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return _vm._l(row.wait, function(item, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.estate_name) +
                                        "\n            "
                                    )
                                  ])
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          2665242625
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "上架时间",
                          prop: "wait",
                          align: "center",
                          className: "my_cell"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return _vm._l(row.wait, function(item, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.start_time) +
                                        "\n            "
                                    )
                                  ])
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          3416434881
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "下架时间",
                          prop: "wait",
                          align: "center",
                          className: "my_cell"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return _vm._l(row.wait, function(item, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.end_time) +
                                        "\n            "
                                    )
                                  ])
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          3771349614
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName === "adTotal1"
        ? _c("div", [
            _c("h2", [_vm._v("广告曝光量统计")]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "max-width": "1000px", margin: "50px auto" } },
              [
                _c(
                  "el-table",
                  { attrs: { data: _vm.ad_List1 } },
                  [
                    _c("el-table-column", {
                      attrs: { label: "楼盘名", prop: "estate_name" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "曝光量", prop: "num" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "广告类型", prop: "position" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "日期", prop: "date" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "areaList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1500px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("常规完整度")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _vm.userTemp
                    ? _c("div", [
                        _vm._v(
                          "负责人：" + _vm._s(_vm.userTemp[_vm.areaValue] || "")
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    staticStyle: { margin: "0 50px" },
                    attrs: { type: "text", placeholder: "回车搜索楼盘名称" },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchAreaReal.apply(null, arguments)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "选择区域",
                        "default-first-option": ""
                      },
                      on: { change: _vm.changeArea },
                      model: {
                        value: _vm.areaValue,
                        callback: function($$v) {
                          _vm.areaValue = $$v
                        },
                        expression: "areaValue"
                      }
                    },
                    _vm._l(_vm.areaArr, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getAreaList()
                      }
                    },
                    model: {
                      value: _vm.checkDate1,
                      callback: function($$v) {
                        _vm.checkDate1 = $$v
                      },
                      expression: "checkDate1"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.areaList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  class: { cur: scope.row.all_tage != "100%" },
                                  staticStyle: { "font-weight": "900" }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.real_estate_name) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2332793019
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "all_tage",
                      label: "整体完成度",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "xs_tage", label: "销售状态", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { class: { cur: scope.row["销售状态"] } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.xs_tage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      132559909
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "yj_tage", label: "预计开盘", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { class: { cur: scope.row["预计开盘"] } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.yj_tage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2513137017
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jz_tage",
                      label: "精装配置表",
                      width: "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { class: { cur: scope.row["精装配置表"] } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.jz_tage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      566727735
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "dz_tage", label: "银行冻资", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { class: { cur: scope.row["银行冻资"] } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.dz_tage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2723554220
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "xq_tage", label: "详情", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { class: { cur: scope.row["详情"] } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.xq_tage) +
                                    "\n          "
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2211419677
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "wd_tage", label: "楼盘问答", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                { class: { cur: scope.row["楼盘问答"] } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.wd_tage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2826776698
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sp_tage", label: "视频", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { class: { cur: scope.row["视频"] } }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.sp_tage) +
                                    "\n          "
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1182766403
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "图库", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  class: { cur: scope.row["图库"] },
                                  on: {
                                    click: function($event) {
                                      return _vm.toEdit(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.tk_tage) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      663146351
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "时间", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.time
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: { color: "#0099ff" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setOneTime(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(scope.row.time) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticStyle: { color: "#ccc" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setOneTime(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            设为目标\n          "
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              scope.row.time
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setOneTime(
                                            scope.row,
                                            "clear"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("取消")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3809767805
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "zhList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1780px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("新房专业完整度")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getZhListType,
                          expression: "getZhListType"
                        }
                      ],
                      attrs: { name: "", id: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.getZhListType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "住宅" } }, [
                        _vm._v("住宅")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "公寓" } }, [
                        _vm._v("公寓")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticStyle: { margin: "0 50px" },
                    attrs: { type: "text", placeholder: "回车搜索楼盘名称" },
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchZhAreaReal.apply(null, arguments)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.generateExcel }
                    },
                    [_vm._v("下载excel")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.zhList, border: "", stripe: "" },
                  on: {
                    "header-click": _vm.sortImageNum2,
                    "filter-change": _vm.filterChange
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "60" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", [_vm._v(_vm._s(scope.$index + 1))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2749146133
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "district",
                      label: "区域",
                      width: "80",
                      filters: _vm.disFilterMap[_vm.$store.state.Counter.city],
                      "filter-method": _vm.filterZhListDis,
                      "column-key": "district"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘名",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "all_tage",
                      label: "综合完整度",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "details_tage",
                      label: "详情完整度",
                      width: "100",
                      filters: _vm.standardsFilter,
                      "filter-method": _vm.filterZhListStandards,
                      "column-key": "details_tage"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "xs",
                      label: "状态",
                      width: "80",
                      filters: _vm.statusFilter,
                      "filter-method": _vm.filterZhListStatus,
                      "column-key": "real_status"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rz",
                      label: "日照",
                      width: "80",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "rz"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hx",
                      label: "户型",
                      width: "80",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "hx"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fj",
                      label: "一房一价",
                      width: "100",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "fj"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hp",
                      label: "航拍",
                      width: "80",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "hp"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ybfvr",
                      label: "精装VR",
                      width: "80",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "ybfvr"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dynamic",
                      label: "置业顾问动态",
                      width: "110",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "dynamic"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hxfb",
                      label: "户型分布",
                      width: "90",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "hxfb"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tabel",
                      label: "精装配置",
                      width: "90",
                      filters: _vm.hasFilter,
                      "filter-method": _vm.filterZhListHas,
                      "column-key": "tabel"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "estate", label: "图片", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "video", label: "视频", width: "80" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sale",
                      label: "销售",
                      filters:
                        _vm.getZhListType == "公寓"
                          ? _vm.hasFilter1
                          : _vm.hasFilter,
                      "filter-method":
                        _vm.getZhListType == "公寓"
                          ? _vm.filterZhListHas_copy
                          : _vm.filterZhListHas,
                      width: "80"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "sellList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "800px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("2020后公示数据")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.sellList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "real_estate_name", label: "楼盘名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "date.advance",
                      label: "预售时间",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rate.house_total",
                      label: "房源套数",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rate.people_total",
                      label: "登记人数",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rate.rate_total",
                      label: "中签率",
                      width: "120"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "statisticsList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "362px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("销售动态统计")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.statisticsList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "day", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "openNum", label: "预计开盘", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dynamicNum",
                      label: "销售动态",
                      width: "120"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "pcList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1300px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("评测合计数据")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _vm._v("\n      起始：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getPcList("pcList")
                      }
                    },
                    model: {
                      value: _vm.checkDate1,
                      callback: function($$v) {
                        _vm.checkDate1 = $$v
                      },
                      expression: "checkDate1"
                    }
                  }),
                  _vm._v("\n      结束：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getPcList("pcList")
                      }
                    },
                    model: {
                      value: _vm.checkDate2,
                      callback: function($$v) {
                        _vm.checkDate2 = $$v
                      },
                      expression: "checkDate2"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.pcList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "range", label: "范围" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "日照", label: "日照" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "户型", label: "户型", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "噪声", label: "噪声", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "景观", label: "景观", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "楼栋", label: "楼栋", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "一房一价", label: "一房一价", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "销售公示", label: "销售公示", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "航拍", label: "航拍", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "航拍标注", label: "航拍标注", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "附近点标注",
                      label: "航拍点标注",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "样板房", label: "样板房vr", width: "100" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "评论(使用)",
                      label: "评论(使用)",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "评论(未使用)",
                      label: "评论(未使用)",
                      width: "100"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "getNewPcList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1112px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("评测总和")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.newPcList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "range", label: "范围", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "日照", label: "模型", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "户型", label: "户型评测", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "户型(无评测)",
                      label: "户型未评测",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "一房一价", label: "一房一价", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "航拍", label: "航拍跑盘", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "样板房vr", label: "样板房vr" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "航拍个数", label: "航拍个数", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "样板房个数",
                      label: "样板房个数",
                      width: "150"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "航拍标注", label: "航拍标注", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "样板房标注",
                      label: "样板房标注",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "户型分布", label: "户型分布", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "视频", label: "视频", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "图片", label: "图片", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "封面图",
                      label: "封面图及标记",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "交房时间", label: "交付时间", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "规控图", label: "规控图", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "视频图片审核",
                      label: "视频图片审核",
                      width: "120"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "totalAdList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1100px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("广告数据统计")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _vm._v("\n      起始：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "picker-options": _vm.pickerOptions,
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    model: {
                      value: _vm.checkDate1,
                      callback: function($$v) {
                        _vm.checkDate1 = $$v
                      },
                      expression: "checkDate1"
                    }
                  }),
                  _vm._v("\n      结束：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "picker-options": _vm.pickerOptions,
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    model: {
                      value: _vm.checkDate2,
                      callback: function($$v) {
                        _vm.checkDate2 = $$v
                      },
                      expression: "checkDate2"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.totalAd } }, [
                    _vm._v(" 查询 ")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.AdList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user", label: "队员" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "当日完成数量" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "总完成数量", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "allTotal",
                      label: "总数据数量",
                      width: "120"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "ptList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1300px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("配套合计数据")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _vm._v("\n      起始：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getPcList("ptList")
                      }
                    },
                    model: {
                      value: _vm.checkDate1,
                      callback: function($$v) {
                        _vm.checkDate1 = $$v
                      },
                      expression: "checkDate1"
                    }
                  }),
                  _vm._v("\n      结束：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getPcList("ptList")
                      }
                    },
                    model: {
                      value: _vm.checkDate2,
                      callback: function($$v) {
                        _vm.checkDate2 = $$v
                      },
                      expression: "checkDate2"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.pcList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "range", label: "范围", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "企业", label: "企业", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "办公", label: "办公", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "厂房", label: "厂房", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "医院", label: "医院", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "学校", label: "学校", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "周边景观", label: "景观", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "商场", label: "商场", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "交通", label: "交通", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "用地性质", label: "用地性质", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "社群问答", label: "社群问答", width: "120" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "tjList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1100px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("匹配统计表格")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _vm._v("\n      起始：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "timestamp",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getStatisticalTable("tjList")
                      }
                    },
                    model: {
                      value: _vm.tjDate1,
                      callback: function($$v) {
                        _vm.tjDate1 = $$v
                      },
                      expression: "tjDate1"
                    }
                  }),
                  _vm._v("\n      结束：\n      "),
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "timestamp",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getStatisticalTable("tjList")
                      }
                    },
                    model: {
                      value: _vm.tjDate2,
                      callback: function($$v) {
                        _vm.tjDate2 = $$v
                      },
                      expression: "tjDate2"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.tjList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user", label: "姓名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "match", label: "匹配" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "cancel", label: "取消匹配" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "wait", label: "待定" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "diff", label: "疑难" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "delete", label: "删除" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "check", label: "已核对" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "remark", label: "修改" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "check2", label: "二轮核对" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "QlList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "660px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("群聊条数查询")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { margin: "0 20px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "选择日期"
                    },
                    on: {
                      change: function($event) {
                        return _vm.getQlList()
                      }
                    },
                    model: {
                      value: _vm.checkDate1,
                      callback: function($$v) {
                        _vm.checkDate1 = $$v
                      },
                      expression: "checkDate1"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.QlList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "负责人" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "count2", label: "群聊条数", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "count1", label: "私聊条数", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "count", label: "总计条数", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "tage", label: "完成度", width: "120" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "maxList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "400px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("2021年最")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.maxList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "type", label: "最" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘名",
                      width: "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "shuju", label: "数据", width: "120" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "shareNumList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "600px", margin: "50px auto" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.shareNumList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user_name", label: "姓名" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "real_estate_name",
                      label: "楼盘名",
                      width: "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "总分享" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "art", label: "文章页面" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "notart", label: "其它页面" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "valueSortList"
        ? _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c(
                "div",
                { staticStyle: { width: "600px" } },
                [
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "center", margin: "20px 0" }
                    },
                    [
                      _vm._v("\n        产业评测排序:"),
                      _vm.valueType
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.valueMap[_vm.valueType]))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: { data: _vm.valueSortList, border: "", stripe: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "index", label: "排名", width: "50" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "real_estate_name", label: "楼盘名" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "score", label: "分数", width: "50" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "value", label: "价值" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goValueMap(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("地图")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getValueSortOfOneEstate(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("明细")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1931746353
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "500px", "margin-left": "50px" } },
                [
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "center", margin: "20px 0" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.valueSortEstateName) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.valueSortListOfEstate,
                        border: "",
                        stripe: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "location_name", label: "名称" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "location_size", label: "等级" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "school_type", label: "二级类" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "dis", label: "距离" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "value", label: "价值" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "matchRecordList"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1000px", margin: "50px auto" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("问答匹配审核")]
              ),
              _vm._v(" "),
              _c("span", [_vm._v("总共还剩下：" + _vm._s([_vm.restreson[0]]))]),
              _vm._v(" "),
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd",
                  type: "date",
                  placeholder: "选择日期"
                },
                on: {
                  change: function($event) {
                    return _vm.checkMatchRecord()
                  }
                },
                model: {
                  value: _vm.wenda,
                  callback: function($$v) {
                    _vm.wenda = $$v
                  },
                  expression: "wenda"
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v("当前日期完成：" + _vm._s([_vm.restreson[1]]))
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.matchRecordList, border: "", stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "input", label: "问题" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "output", label: "匹配" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "help", label: "帮助" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "create_time", label: "时间" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "400" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setMatchRecord(
                                        scope.row,
                                        scope.$index,
                                        1
                                      )
                                    }
                                  }
                                },
                                [_vm._v("正确")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setMatchRecord(
                                        scope.row,
                                        scope.$index,
                                        2
                                      )
                                    }
                                  }
                                },
                                [_vm._v("匹配错误")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setMatchRecord(
                                        scope.row,
                                        scope.$index,
                                        3
                                      )
                                    }
                                  }
                                },
                                [_vm._v("无需回答")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setMatchRecord(
                                        scope.row,
                                        scope.$index,
                                        4
                                      )
                                    }
                                  }
                                },
                                [_vm._v("不是问题")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      988739941
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "assignCustomer"
        ? _c(
            "div",
            { staticStyle: { "max-width": "1300px", margin: "50px 200px" } },
            [
              _c(
                "h2",
                { staticStyle: { "text-align": "center", margin: "20px 0" } },
                [_vm._v("分配客户情况")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "margin-bottom": "10px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "选择楼盘",
                        "default-first-option": "",
                        "remote-method": _vm.searchEstate,
                        remote: ""
                      },
                      model: {
                        value: _vm.estateValue,
                        callback: function($$v) {
                          _vm.estateValue = $$v
                        },
                        expression: "estateValue"
                      }
                    },
                    _vm._l(_vm.matchEstates, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.real_estate_name, value: item.id }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.getGiveClientInfo(_vm.estateValue)
                        }
                      }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.assignCustomer, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "200" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "当天分配客户" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sale",
                      label: "置业顾问姓名和分到的客户数量",
                      width: "400"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return _vm._l(scope.row.sales, function(
                              sale,
                              index
                            ) {
                              return _c("div", { key: index }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(sale.user_name) +
                                    " : " +
                                    _vm._s(sale.num) +
                                    "个\n          "
                                )
                              ])
                            })
                          }
                        }
                      ],
                      null,
                      false,
                      1593462685
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "testReply"
        ? _c(
            "div",
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "选择楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: "",
                    clearable: ""
                  },
                  model: {
                    value: _vm.chooseHotId,
                    callback: function($$v) {
                      _vm.chooseHotId = $$v
                    },
                    expression: "chooseHotId"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "要回复的答案类" },
                model: {
                  value: _vm.testReplyWord,
                  callback: function($$v) {
                    _vm.testReplyWord = $$v
                  },
                  expression: "testReplyWord"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.sendTestReply(
                        _vm.testReplyWord,
                        _vm.chooseHotId
                      )
                    }
                  }
                },
                [_vm._v("发送")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ifrecommendrealestate
        ? _c(
            "div",
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "选择楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: ""
                  },
                  model: {
                    value: _vm.recommandEstate,
                    callback: function($$v) {
                      _vm.recommandEstate = $$v
                    },
                    expression: "recommandEstate"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.setThisRealestate()
                    }
                  }
                },
                [_vm._v("上传此楼盘")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "setTopicLabel"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _vm._v("\n    选择类目：\n    "),
              _vm._l(_vm.topicLabels, function(label, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "input-box" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          placeholder: index + 1 + "级类目"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onTopicLabelChange($event, index)
                          }
                        },
                        model: {
                          value: _vm.topicLabels[index],
                          callback: function($$v) {
                            _vm.$set(_vm.topicLabels, index, $$v)
                          },
                          expression: "topicLabels[index]"
                        }
                      },
                      _vm._l(_vm.topicLabelOptions[index], function(item) {
                        return _c("el-option", {
                          key: item,
                          attrs: { label: item, value: item }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.listName == "checkAutoReply"
        ? _c(
            "div",
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.judgeQuestion,
                    expression: "judgeQuestion"
                  }
                ],
                attrs: { type: "text", placeholder: "输入问题" },
                domProps: { value: _vm.judgeQuestion },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.judgeQuestion = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "搜索楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: ""
                  },
                  model: {
                    value: _vm.judgeQuestionEstate,
                    callback: function($$v) {
                      _vm.judgeQuestionEstate = $$v
                    },
                    expression: "judgeQuestionEstate"
                  }
                },
                _vm._l(_vm.matchEstates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.checkAutoReply }
                },
                [_vm._v("检查")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "购房通公示",
            visible: _vm.dialogTableVisible,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.noticeData, border: "", stripe: "" } },
            [
              _c("el-table-column", {
                attrs: { property: "name", label: "楼盘名", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "status_name",
                  label: "状态",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.getGFTcontent(scope)
                              }
                            }
                          },
                          [_vm._v("抓取")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "type", label: "来源", align: "center" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "white" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n            顾问功能\n            "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("顾问段类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          顾问审核\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("顾问段类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          客户功能\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("客户端类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          客户审核\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("客户端类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          小程序群功能\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("客户端类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          合作公号\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("客户端类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          海报\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("客户端类目")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          数据统计结果\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("数据统计")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          顾问统计\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("数据统计")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cititle" }, [
      _vm._v("\n          客户统计\n          "),
      _c("div", { staticClass: "threetitle" }, [_vm._v("数据统计")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b154409", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b154409","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Other.vue
// module id = null
// module chunks = 